var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { ref: "page", staticClass: "page-card page-card--gold" }, [
    _c(
      "section",
      { ref: "visual", staticClass: "visual-gold" },
      [
        _c("v-image", {
          staticClass: "visual-gold__background",
          attrs: {
            tiny: {
              default: require("@/images/cards/gold/visual-bg.jpg"),
              retina: require("@/images/cards/gold/visual-bg@2.jpg")
            },
            alt: "background"
          }
        }),
        _vm._v(" "),
        _c(
          "v-row",
          { staticClass: "visual-gold__row", attrs: { variant: "flex" } },
          [
            _c("v-column", { attrs: { large: 12 } }, [
              _c("div", { staticClass: "visual-gold__content" }, [
                _c(
                  "div",
                  {
                    ref: "cardReal",
                    staticClass: "visual-gold__card-wrapper",
                    staticStyle: { height: "210px" }
                  },
                  [
                    _c("v-icon", {
                      staticClass: "visual-gold__card",
                      attrs: { name: "symbols/cards/gold" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "cardContent", staticClass: "visual-gold__inner" },
                  [
                    _c("v-typo", {
                      staticClass: "visual-gold__headline",
                      attrs: { variant: "h1" },
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cards.gold.visual.headline"))
                      }
                    }),
                    _vm._v(" "),
                    _c("v-typo", {
                      staticClass: "visual-gold__perex",
                      attrs: { variant: "body-perex" },
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cards.gold.visual.paragraph"))
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "v-button",
                      {
                        staticClass: "visual-gold__button",
                        attrs: {
                          to: {
                            query: {
                              modal: _vm.appModalName
                            },
                            params: {
                              card: "gold"
                            }
                          },
                          element: "a",
                          variant: "black"
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("button.getItNow")) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "scroll", staticClass: "visual-gold__scroll-down" },
                  [_c("v-icon", { attrs: { name: "ui/mouse" } })],
                  1
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "ultimateCard", staticClass: "ultimate-card" },
      [
        _c(
          "div",
          { staticClass: "ultimate-card__bg" },
          [
            _c("v-image", {
              attrs: {
                "aspect-ratio": false,
                tiny: {
                  default: require("@/images/gold/ultimate/bg.jpg"),
                  retina: require("@/images/gold/ultimate/bg@2.jpg")
                },
                alt: "Background"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "ultimate-card__card-wrapper",
            on: {
              mouseenter: _vm.handleMouseEnter,
              mousemove: _vm.handleMove,
              mouseout: _vm.handleMouseOut
            }
          },
          [
            _c(
              "div",
              { ref: "card", staticClass: "ultimate-card__card" },
              [_c("v-icon", { attrs: { name: "symbols/cards/gold" } })],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "v-row",
          {
            staticClass: "ultimate-card__row",
            attrs: { horizontal: "center", variant: "flex", vertical: "center" }
          },
          [
            _c(
              "v-column",
              { staticClass: "ultimate-card__column", attrs: { large: 12 } },
              [
                _c(
                  "div",
                  { staticClass: "ultimate-card__content" },
                  [
                    _c("v-typo", {
                      attrs: { variant: "h1" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("cards.gold.ultimate.headline")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("v-typo", {
                      staticClass: "ultimate-card__paragraph",
                      attrs: { variant: "body-paragraph" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("cards.gold.ultimate.paragraph")
                        )
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "carousel", staticClass: "carousel" },
      [
        _c(
          "v-row",
          { staticClass: "carousel__row", attrs: { varaint: "flex" } },
          [
            _c("v-column", { attrs: { large: 12 } }, [
              _c(
                "div",
                { staticClass: "carousel__wrapper carousel__wrapper--gold" },
                [
                  _c("div", { ref: "sticky", staticClass: "carousel__left" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "carousel__sticky",
                          { "carousel__sticky--active": !_vm.isIE }
                        ]
                      },
                      [
                        _c("div", { staticClass: "carousel__sticky-wrapper" }, [
                          _c(
                            "div",
                            {
                              ref: "animationWrapper",
                              staticClass: "carousel__image-wrapper"
                            },
                            [
                              _c(
                                "div",
                                {
                                  ref: "carouselVisualLive",
                                  staticClass: "carousel__visual"
                                },
                                [
                                  _c("v-image", {
                                    attrs: {
                                      "aspect-ratio": 1,
                                      tiny: {
                                        default: require("@/images/gold/carousel/live/live.png"),
                                        retina: require("@/images/gold/carousel/live/live@2.png")
                                      },
                                      alt: "todo fill alt"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  ref: "carouselVisualTravel",
                                  staticClass: "carousel__visual"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        id:
                                          "a0771a15-0d53-4f3c-88eb-0423b317a6ca",
                                        "data-name": "Vrstva 1",
                                        viewBox: "0 0 383 380",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink"
                                      }
                                    },
                                    [
                                      _c(
                                        "defs",
                                        [
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "b0592bbc-3ba1-4456-b11c-27aff55fb57f",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "41.26",
                                                x2: "52.37",
                                                y1: "198.41",
                                                y2: "187.3"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#f8f1c3"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#e3c963"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "ac1c9d2e-ba7b-4439-b052-3fee2df60408",
                                              x1: "42.01",
                                              x2: "51.61",
                                              "xlink:href":
                                                "#b0592bbc-3ba1-4456-b11c-27aff55fb57f",
                                              y1: "197.65",
                                              y2: "188.05"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "be08b5dc-6598-42de-afd2-6911f2dd62d3",
                                              x1: "36.81",
                                              x2: "56.81",
                                              "xlink:href":
                                                "#b0592bbc-3ba1-4456-b11c-27aff55fb57f",
                                              y1: "202.85",
                                              y2: "182.85"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "aa331cef-d196-43cb-a6ed-f24a5fe80925",
                                              x1: "32.37",
                                              x2: "61.26",
                                              "xlink:href":
                                                "#b0592bbc-3ba1-4456-b11c-27aff55fb57f",
                                              y1: "207.3",
                                              y2: "178.41"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "f1dda938-81e0-4ec1-9eea-3b8a21efc320",
                                                gradientTransform:
                                                  "translate(-38.63 55.29) rotate(-20.63)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "123.66",
                                                x2: "123.66",
                                                y1: "138.23",
                                                y2: "135.33"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#6d6e71"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.28",
                                                  "stop-color": "#f6f6f6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.29",
                                                  "stop-color": "#e5e6e6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.34",
                                                  "stop-color": "#c0c1c3"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.38",
                                                  "stop-color": "#a3a5a7"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.43",
                                                  "stop-color": "#8f9093"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.47",
                                                  "stop-color": "#828487"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.52",
                                                  "stop-color": "#7e8083"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.54",
                                                  "stop-color": "#86888b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.59",
                                                  "stop-color": "#9b9d9f"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.64",
                                                  "stop-color": "#bebfc1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.7",
                                                  "stop-color": "#efefef"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.72",
                                                  "stop-color": "#fff"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#5a5b5d"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "ac913104-fd4b-4160-86b0-344b25cb451b",
                                                gradientTransform:
                                                  "translate(87922.49 -18183.85) rotate(-20.63) scale(102.79 30.24)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "-861.88",
                                                x2: "-861.72",
                                                y1: "-456",
                                                y2: "-456"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#523613"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.13",
                                                  "stop-color": "#302011"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.18",
                                                  "stop-color": "#3b2613"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.23",
                                                  "stop-color": "#4a3013"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.32",
                                                  "stop-color": "#6a4610"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.38",
                                                  "stop-color": "#7d5c22"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.47",
                                                  "stop-color": "#a6813d"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.62",
                                                  "stop-color": "#b68d45"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.64",
                                                  "stop-color": "#c6a350"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.67",
                                                  "stop-color": "#ddc05f"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.69",
                                                  "stop-color": "#e6cc65"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.79",
                                                  "stop-color": "#fdfadb"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.85",
                                                  "stop-color": "#fdfadb"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.92",
                                                  "stop-color": "#bb9f5a"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#87601c"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "b9e89fef-a341-47e7-9d61-17f3a62b9ac0",
                                                gradientTransform:
                                                  "matrix(121.47, -45.74, 35.1, 93.23, 121944.52, 5488.6)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "-863.48",
                                                x2: "-863.54",
                                                y1: "-481.2",
                                                y2: "-481.13"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#87601c"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.29",
                                                  "stop-color": "#ffea86"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.37",
                                                  "stop-color": "#fdef89"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.4",
                                                  "stop-color": "#fcf18b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.41",
                                                  "stop-color": "#fbec83"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.52",
                                                  "stop-color": "#eece54"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.63",
                                                  "stop-color": "#ffea86"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.73",
                                                  "stop-color": "#fdef89"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.76",
                                                  "stop-color": "#fcf18b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.81",
                                                  "stop-color": "#dac065"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.94",
                                                  "stop-color": "#945e22"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#7c3e11"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "a038a928-f4e0-48cb-984d-c8b44cbefd00",
                                                gradientTransform:
                                                  "translate(95014.5 15216.05) rotate(-20.63) scale(96.85 98.84)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "-861.7",
                                                x2: "-861.54",
                                                y1: "-481.19",
                                                y2: "-481.05"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#87601c"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.11",
                                                  "stop-color": "#ffea86"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.24",
                                                  "stop-color": "#fdef89"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.27",
                                                  "stop-color": "#fcf18b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.3",
                                                  "stop-color": "#fbec83"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.5",
                                                  "stop-color": "#eece54"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.57",
                                                  "stop-color": "#ffea86"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.72",
                                                  "stop-color": "#fdef89"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.76",
                                                  "stop-color": "#fcf18b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.81",
                                                  "stop-color": "#dac065"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.94",
                                                  "stop-color": "#945e22"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#7c3e11"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "b554cf5f-e7e9-41d3-9ba4-1271329ca92d",
                                              gradientTransform:
                                                "translate(11036.93 -3013.94) rotate(-20.63) scale(14.01 4.12)",
                                              x1: "-807.12",
                                              x2: "-806.96",
                                              "xlink:href":
                                                "#ac913104-fd4b-4160-86b0-344b25cb451b",
                                              y1: "-218.64",
                                              y2: "-218.64"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "a94d4f39-8c42-4a0e-93a9-0e812c36b2eb",
                                              gradientTransform:
                                                "matrix(19.86, -7.48, 6.69, 17.76, 19481.12, 1620.15)",
                                              x1: "-828.27",
                                              x2: "-828.34",
                                              "xlink:href":
                                                "#b9e89fef-a341-47e7-9d61-17f3a62b9ac0",
                                              y1: "-432.76",
                                              y2: "-432.66"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "bce63e68-b62a-4192-9d6a-6e109aabc159",
                                              gradientTransform:
                                                "matrix(15.65, -5.89, 6.69, 17.76, 15824.52, 2996.95)",
                                              x1: "-817.56",
                                              x2: "-817.43",
                                              "xlink:href":
                                                "#a038a928-f4e0-48cb-984d-c8b44cbefd00",
                                              y1: "-432.83",
                                              y2: "-432.69"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id:
                                              "efbd9849-4176-4277-a30d-f1419f499443",
                                            "data-name": "lines"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M47.55,192.89q43.13-40,92.05-55.87t121.61-4.87",
                                              fill: "none",
                                              stroke: "#fff",
                                              "stroke-dasharray": "0 6",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M261.21,133.25q59.58-16.27,89.07-23.59t17.94,7.77",
                                              fill: "none",
                                              stroke: "#fff",
                                              "stroke-dasharray": "0 6",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M15.68,133.93q-27.39-7.31-6.94,15.3c20.44,22.6,54.48,54.7,121.38,95.79q66.9,41.1,146.22,68.6",
                                              fill: "none",
                                              stroke: "#fff",
                                              "stroke-dasharray": "0 6",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M139.6,137q48.93-15.86,121.61-3.77",
                                              fill: "none",
                                              stroke: "#fff",
                                              "stroke-dasharray": "0 6",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "stroke-width": "2"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id:
                                              "e431a674-1d1b-425a-b2b4-f8a624bc170b",
                                            "data-name": "pins"
                                          }
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "f14a336f-f01c-401c-bb48-6818d0c59bd6",
                                                "data-name": "1"
                                              }
                                            },
                                            [
                                              _c("circle", {
                                                attrs: {
                                                  cx: "47.38",
                                                  cy: "113.82",
                                                  fill: "#E3C963",
                                                  r: "39.47",
                                                  stroke: "#000"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("line", {
                                                attrs: {
                                                  id:
                                                    "b0e6da27-23ca-40ea-ae12-38aeab88efaa",
                                                  "data-name": "Shape",
                                                  fill: "#E3C963",
                                                  stroke: "#000",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  x1: "47.21",
                                                  x2: "47.21",
                                                  y1: "116.65",
                                                  y2: "127.85"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("line", {
                                                attrs: {
                                                  id:
                                                    "aebd8cde-1868-49eb-8243-091972a66182",
                                                  "data-name": "Shape",
                                                  fill: "#E3C963",
                                                  stroke: "#000",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  x1: "43.05",
                                                  x2: "51.38",
                                                  y1: "127.85",
                                                  y2: "127.85"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("line", {
                                                attrs: {
                                                  id:
                                                    "be8c3fe5-b120-4afb-b280-5ab4cae80a59",
                                                  "data-name": "Shape",
                                                  fill: "#E3C963",
                                                  stroke: "#000",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  x1: "42.38",
                                                  x2: "52.05",
                                                  y1: "98.65",
                                                  y2: "98.65"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("polygon", {
                                                attrs: {
                                                  id:
                                                    "e7a3b3c6-a139-4946-a52c-fdccd4694d33",
                                                  "data-name": "Rectangle",
                                                  fill: "#E3C963",
                                                  points:
                                                    "42.21 90.25 52.21 90.25 52.21 111.25 47.21 116.25 42.21 111.25 42.21 90.25",
                                                  stroke: "#000",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "b55e6174-76c2-41f5-9381-40826389c258",
                                                  d:
                                                    "M48.3,102.65a.4.4,0,1,0,0,.8.4.4,0,1,0,0-.8",
                                                  "data-name": "Shape",
                                                  fill: "#E3C963",
                                                  stroke: "#000",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "b95c247b-869a-4e1e-a1f9-ce2842c77f25",
                                                  d:
                                                    "M45.13,106.35a.4.4,0,1,0,.42.4.41.41,0,0,0-.42-.4",
                                                  "data-name": "Shape",
                                                  fill: "#E3C963",
                                                  stroke: "#000",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "b9b8d043-1d93-48e4-b22a-c32ba1a84591",
                                                  d:
                                                    "M49.46,108a.4.4,0,1,0,0,.8.4.4,0,1,0,0-.8",
                                                  "data-name": "Shape",
                                                  fill: "#E3C963",
                                                  stroke: "#000",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "b030e33a-d39f-41f9-8262-d8bab51f3e4a",
                                                "data-name": "2"
                                              }
                                            },
                                            [
                                              _c("circle", {
                                                attrs: {
                                                  cx: "260.98",
                                                  cy: "135.62",
                                                  fill: "#E3C963",
                                                  r: "39.47",
                                                  stroke: "#000"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M246,117.3a2.25,2.25,0,1,0,3.87,2.1.75.75,0,0,1,.82-.54l3.84.54a.76.76,0,0,1,.65.79A6.75,6.75,0,1,1,243.45,115Zm2.79,3.43,2.64,4.84m-5.69-5.74-3.62,2m5-.89-1.39,4.74m.31-8.36,1.19-.57a3,3,0,0,0,1.65-3.19,1.37,1.37,0,0,0-.86-1.08,1.38,1.38,0,0,0-1.37.18L243.45,115m2,25.21a9.25,9.25,0,0,1,9.37-8.73h1.92a1.53,1.53,0,0,0,1.26-.69,12,12,0,1,1,9.95,18.69h-13.5a9,9,0,0,1-9-9.27ZM254.6,136h4.86a1.47,1.47,0,0,0,1.4-1,7.5,7.5,0,1,1,7.08,10h-13.5a4.5,4.5,0,0,1-4.42-5.39A4.61,4.61,0,0,1,254.6,136Zm13.71-2.25a3.38,3.38,0,1,0,3.38,3.38A3.37,3.37,0,0,0,268.31,133.75Z",
                                                  fill: "none",
                                                  stroke: "#000"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "b5ff1c78-63e3-413f-a4b9-3790853a3f32",
                                                "data-name": "3"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M46.81,183.25a9.6,9.6,0,1,1-9.6,9.6A9.6,9.6,0,0,1,46.81,183.25Z",
                                                  fill: "none",
                                                  stroke:
                                                    "url(#b0592bbc-3ba1-4456-b11c-27aff55fb57f)",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  "stroke-width": "0.8"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M46.81,188.05a4.8,4.8,0,1,1-4.8,4.8A4.8,4.8,0,0,1,46.81,188.05Z",
                                                  fill:
                                                    "url(#ac1c9d2e-ba7b-4439-b052-3fee2df60408)",
                                                  "fill-rule": "evenodd"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                staticStyle: {
                                                  isolation: "isolate"
                                                },
                                                attrs: {
                                                  d:
                                                    "M46.81,175.25a17.6,17.6,0,1,1-17.6,17.6A17.6,17.6,0,0,1,46.81,175.25Z",
                                                  fill: "none",
                                                  opacity: "0.25",
                                                  stroke:
                                                    "url(#be08b5dc-6598-42de-afd2-6911f2dd62d3)",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  "stroke-width": "0.8"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                staticStyle: {
                                                  isolation: "isolate"
                                                },
                                                attrs: {
                                                  d:
                                                    "M46.81,167.25a25.6,25.6,0,1,1-25.6,25.6A25.6,25.6,0,0,1,46.81,167.25Z",
                                                  fill: "none",
                                                  opacity: "0.1",
                                                  stroke:
                                                    "url(#aa331cef-d196-43cb-a6ed-f24a5fe80925)",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  "stroke-width": "0.8"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "f43c1b8d-a23f-4caf-af58-de0240fcfe73",
                                                "data-name": "4"
                                              }
                                            },
                                            [
                                              _c("circle", {
                                                attrs: {
                                                  cx: "276.21",
                                                  cy: "303.85",
                                                  fill: "#E3C963",
                                                  r: "39.47",
                                                  stroke: "#000"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "a4372273-7d76-4fe8-a253-51e2502cab1a",
                                                  d:
                                                    "M264.21,300.46h24l-12.63,16.42Zm11.37,16.42V327m-5.05,0h10.1M268,305.52h16.42m-8.84,10.1,7.58-20.21m1.26-6.88a3.29,3.29,0,1,1-3.29,3.29A3.29,3.29,0,0,1,284.42,288.53Zm1.29-.28,3-8",
                                                  "data-name": "2",
                                                  fill: "none",
                                                  stroke: "#000"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id:
                                              "b7a33f2f-e4ec-4c2e-9b9f-683126806c00",
                                            "data-name": "card"
                                          }
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "e20fdf0b-a7c6-4577-99e2-21ef82028ceb",
                                                "data-name":
                                                  "b6d790e3-39ce-4026-a312-ca792fb3e41a"
                                              }
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  id:
                                                    "acc154a2-3318-41b2-ba01-4aaa36e812b4",
                                                  "data-name":
                                                    "b274c2ac-b9cb-417f-9f0c-3a4b70ddf97b",
                                                  fill: "#222226",
                                                  height: "38.2",
                                                  rx: "4.5",
                                                  transform:
                                                    "translate(-38.51 60.08) rotate(-20.63)",
                                                  width: "58.28",
                                                  x: "116.63",
                                                  y: "116.73"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "b12bb640-3308-43a1-8e95-c808f3136888",
                                                    "data-name":
                                                      "b1673a7a-62c2-4d60-b5df-86d3cb85dc05"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "f6c6f99e-b2f2-4b7b-a85b-fafbecf0408a",
                                                      d:
                                                        "M125.64,150.24a14.18,14.18,0,0,1,17.65,6.9l-.14.05a14,14,0,0,0-18.83-6.2,13.73,13.73,0,0,0-3.11,2.13l-.06-.15A14,14,0,0,1,125.64,150.24Zm-.42-1.1a15.37,15.37,0,0,1,19.18,7.59l-.15.05A15.19,15.19,0,0,0,120.77,152l-.06-.18A15.5,15.5,0,0,1,125.22,149.14Zm-.41-1.09a16.52,16.52,0,0,1,20.69,8.26l-.15.05a16.34,16.34,0,0,0-25-5.57l-.06-.16A16.35,16.35,0,0,1,124.81,148.05Zm-.41-1.1a17.69,17.69,0,0,1,22.2,8.94l-.15.06a17.52,17.52,0,0,0-26.55-6.32l-.06-.15A17.71,17.71,0,0,1,124.4,147Zm-.42-1.1a18.89,18.89,0,0,1,23.73,9.63l-.15.05a18.7,18.7,0,0,0-28.09-7l-.06-.15A18.61,18.61,0,0,1,124,145.85Zm-.41-1.1a20.05,20.05,0,0,1,25.24,10.31l-.15.06a19.88,19.88,0,0,0-26.42-9.64,20.11,20.11,0,0,0-3.2,1.87l-.06-.16A20,20,0,0,1,123.57,144.75Zm-.41-1.08a21.23,21.23,0,0,1,26.73,11l-.13,0a21.09,21.09,0,0,0-28-10.28,21.45,21.45,0,0,0-3.16,1.8l0-.15A21.65,21.65,0,0,1,123.16,143.67Zm-.42-1.11A22.41,22.41,0,0,1,151,154.23l-.13.05a22.29,22.29,0,0,0-32.7-9.2l-.05-.14A22.37,22.37,0,0,1,122.74,142.56Zm-.41-1.1a23.59,23.59,0,0,1,29.78,12.36l-.15.05a23.39,23.39,0,0,0-31-11.69,22.16,22.16,0,0,0-3.24,1.78l-.05-.15A23.63,23.63,0,0,1,122.33,141.46Zm-.41-1.1a24.76,24.76,0,0,1,31.3,13l-.15.06a24.58,24.58,0,0,0-35.73-10.63l-.06-.15A25.14,25.14,0,0,1,121.92,140.36Zm-.42-1.1A26,26,0,0,1,154.32,153l-.16,0a25.77,25.77,0,0,0-34-13,26.38,26.38,0,0,0-3.19,1.7l-.06-.17A26,26,0,0,1,121.5,139.26Zm-.41-1.09a27.1,27.1,0,0,1,34.33,14.4l-.15.06a26.93,26.93,0,0,0-35.52-13.75,26.54,26.54,0,0,0-3.25,1.72l-.06-.16A27.4,27.4,0,0,1,121.09,138.17Zm-.42-1.11a28.27,28.27,0,0,1,35.86,15.09l-.16.06a28.11,28.11,0,0,0-37-14.44,26.67,26.67,0,0,0-3.27,1.7l-.06-.15A28.6,28.6,0,0,1,120.67,137.06Zm-.42-1.14a29.49,29.49,0,0,1,37.41,15.81l-.14.05a29.33,29.33,0,0,0-38.62-15.15,29.68,29.68,0,0,0-3.27,1.68l0-.15A29.9,29.9,0,0,1,120.25,135.92Zm-.42-1.09a30.69,30.69,0,0,1,38.94,16.48l-.15.06a30.49,30.49,0,0,0-40.13-15.83,28.67,28.67,0,0,0-3.27,1.66l-.06-.15A31.18,31.18,0,0,1,119.83,134.83Zm-.41-1.1a31.86,31.86,0,0,1,40.45,17.17l-.15,0a31.68,31.68,0,0,0-41.65-16.51,30.25,30.25,0,0,0-3.27,1.64l-.06-.15A32.2,32.2,0,0,1,119.42,133.73Zm-.41-1.1a33,33,0,0,1,42,17.85l-.16.06a32.86,32.86,0,0,0-41.75-17.76,33.76,33.76,0,0,0-4.68,2.19l-.06-.14A32.31,32.31,0,0,1,119,132.63Zm-.42-1.1a34.21,34.21,0,0,1,43.48,18.54l-.15.05a34,34,0,0,0-43.27-18.44,35,35,0,0,0-4.69,2.18l-.06-.15A35.61,35.61,0,0,1,118.59,131.53Zm-.42-1.13a35.41,35.41,0,0,1,45,19.24l-.14.06a35.27,35.27,0,0,0-44.85-19.15,34.79,34.79,0,0,0-4.68,2.16l-.06-.15A36.32,36.32,0,0,1,118.17,130.4Zm-.42-1.1a36.61,36.61,0,0,1,46.56,19.93l-.15.05a36.44,36.44,0,0,0-46.35-19.84,37.56,37.56,0,0,0-4.61,2.11l0-.16A36.9,36.9,0,0,1,117.75,129.3Zm-.42-1.14a37.82,37.82,0,0,1,48.11,20.64l-.13,0a37.67,37.67,0,0,0-47.93-20.54,41.78,41.78,0,0,0-4.16,1.85,1.06,1.06,0,0,0,0-.19A40,40,0,0,1,117.33,128.16Z",
                                                      "data-name":
                                                        "ea33dded-e609-4f59-a3e0-f8608158c426",
                                                      fill: "#302e2f"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "a68cb5eb-cddd-4156-85f7-c0de05d012fe",
                                                      d:
                                                        "M175.35,131.69l.14.36a26.57,26.57,0,0,1-33.24-15.31l.11,0A26.47,26.47,0,0,0,175.35,131.69Zm-.29-.78,0,.1a25.69,25.69,0,0,1-32-14.57l.09,0A25.62,25.62,0,0,0,175.06,130.91Zm-.3-.78,0,.11a24.88,24.88,0,0,1-31-14.09l.1,0a24.79,24.79,0,0,0,30.83,14Zm-.29-.79,0,.1a24,24,0,0,1-29.87-13.59l.1,0a24,24,0,0,0,29.74,13.53Zm-.3-.78.13.33a23.21,23.21,0,0,1-28.9-13.33l.12,0a23.1,23.1,0,0,0,28.65,13Zm-.29-.77.12.32a22.38,22.38,0,0,1-27.83-12.84l.12,0a22.27,22.27,0,0,0,27.59,12.57Zm-.29-.77.12.32A21.55,21.55,0,0,1,146.94,115l.1,0A21.47,21.47,0,0,0,173.59,127Zm-.29-.77,0,.1a20.73,20.73,0,0,1-25.62-11.67l.11,0a20.63,20.63,0,0,0,25.47,11.61Zm-.3-.81.11.31a19.85,19.85,0,0,1-24.59-11.37l.11,0A19.78,19.78,0,0,0,173,125.44Zm-.29-.77.11.3a19,19,0,0,1-23.53-10.88l.12,0A19,19,0,0,0,172.71,124.67Zm-.29-.78.11.31a18.22,18.22,0,0,1-22.46-10.4l.11,0A18.12,18.12,0,0,0,172.42,123.89Zm-.3-.77.12.3a17.37,17.37,0,0,1-21.4-9.91l.11,0A17.3,17.3,0,0,0,172.12,123.12Zm-.29-.77.11.29a16.54,16.54,0,0,1-20.33-9.42l.12,0a16.46,16.46,0,0,0,20.1,9.18Zm-.29-.77.11.29a15.73,15.73,0,0,1-19.26-9l.11,0a15.64,15.64,0,0,0,19,8.7Zm-.29-.77.11.28a14.91,14.91,0,0,1-18.2-8.46l.11,0a14.83,14.83,0,0,0,18,8.22Zm-11.72-2.23a14.08,14.08,0,0,0,11.4,1.38l0,.07a14,14,0,0,1-11.58-1.54h0Zm11.14.68.13.34a13.44,13.44,0,0,1-6.11.39,13.27,13.27,0,0,1-10-7.93l.11,0A13.17,13.17,0,0,0,170.67,119.26Zm-.29-.78.1.27a12.44,12.44,0,0,1-15-7l.12,0a12.34,12.34,0,0,0,14.78,6.77Zm-.29-.77,0,.1a11.61,11.61,0,0,1-13.86-6.35l.1,0A11.52,11.52,0,0,0,170.09,117.71Zm-.3-.78,0,.11A10.77,10.77,0,0,1,157,111.17l.1,0A10.7,10.7,0,0,0,169.79,116.93Zm-.29-.77.1.25a10.09,10.09,0,0,1-4.37.24,10,10,0,0,1-7.43-5.76l.13,0A9.86,9.86,0,0,0,169.5,116.16Zm-10.16,2.31a14.05,14.05,0,0,1-5.39-6.13l.1,0a13.85,13.85,0,0,0,5.15,6.08l.15.1Z",
                                                      "data-name":
                                                        "a05d1805-33ea-4e0b-9435-b7fc655dced5",
                                                      fill: "#231f20"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "a3a33cc5-1a87-4b9f-924e-9fd1c863a07d",
                                                      d:
                                                        "M151.25,148.19a8.81,8.81,0,0,1,6.72,3.45l-.06,0a8.77,8.77,0,0,0-15.69,5.91l-.09,0a8.89,8.89,0,0,1,9.12-9.42ZM148,149.25a8.31,8.31,0,0,1,9.42,2.58l-.06,0a8.26,8.26,0,0,0-14.68,4.89c0,.22,0,.43,0,.64l-.06,0A8.3,8.3,0,0,1,148,149.25Zm3.18,0a7.74,7.74,0,0,1,5.72,2.79h0a7.74,7.74,0,0,0-13.66,5.15l-.06,0a7.78,7.78,0,0,1,7.6-8A3.23,3.23,0,0,1,151.22,149.24Zm-2.81,1a7.26,7.26,0,0,1,8,2l-.06,0a7.22,7.22,0,0,0-12.62,4.54V157l-.06,0A7.27,7.27,0,0,1,148.41,150.22Zm2.78.05a6.7,6.7,0,0,1,4.72,2.15l-.06,0a6.7,6.7,0,0,0-11.58,4.36l-.06,0a6.85,6.85,0,0,1,.6-2.59A6.75,6.75,0,0,1,151.19,150.27Zm0,.52a6.21,6.21,0,0,1,4.22,1.83l0,0a6.18,6.18,0,0,0-10.53,4l-.06,0a6.23,6.23,0,0,1,6.43-5.83Z",
                                                      "data-name":
                                                        "fc3624dc-d130-4ca1-8f86-962be4fcf1da",
                                                      fill: "#231f20"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "b375b91c-ce06-4718-bd83-0192f9629f55",
                                                      d:
                                                        "M131.54,129.1a20.5,20.5,0,0,1-15,11.71l0-.07a20.21,20.21,0,0,0,3.58-1,20.46,20.46,0,0,0,13.23-19.64l.07,0A20.29,20.29,0,0,1,131.54,129.1Zm-.53-.41-.07.14a19.71,19.71,0,0,1-11.07,10.37,20.31,20.31,0,0,1-3.59,1l0-.07a21.07,21.07,0,0,0,3.58-1,19.81,19.81,0,0,0,12.8-18.78l.08,0A19.72,19.72,0,0,1,131,128.69Zm-.65-.13a19.22,19.22,0,0,1-14.31,11l0-.08a18.75,18.75,0,0,0,3.6-1A19.15,19.15,0,0,0,132,120.6l.08,0A19,19,0,0,1,130.36,128.56Zm-.6-.26A18.6,18.6,0,0,1,115.82,139l0-.07a18.52,18.52,0,0,0,15.55-18l.08,0A18.41,18.41,0,0,1,129.76,128.3Zm-.58-.26a17.81,17.81,0,0,1-10,9.35,18.12,18.12,0,0,1-3.61,1l0-.06a17.89,17.89,0,0,0,15.14-17.19l.08,0A17.89,17.89,0,0,1,129.18,128Zm-.58-.27a17.28,17.28,0,0,1-13.24,10l0-.07a18,18,0,0,0,3.61-.92,17.22,17.22,0,0,0,11.12-15.41l.07,0A17,17,0,0,1,128.6,127.77Z",
                                                      "data-name":
                                                        "f2489913-98c0-4300-8dc2-6955e6df0ca4",
                                                      fill: "#231f20"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "bb72a487-882c-4730-be67-b0d4ad71ad88",
                                                      d:
                                                        "M125.9,161.84a.16.16,0,0,1,.21.1.17.17,0,0,1,0,.17.17.17,0,0,1-.19,0,.14.14,0,0,1-.09-.15A.15.15,0,0,1,125.9,161.84Zm1.16-.44a.16.16,0,0,1,.18.27.19.19,0,0,1-.19,0,.15.15,0,0,1-.09-.16.16.16,0,0,1,.1-.15Zm1.17-.44a.17.17,0,0,1,.17.28.19.19,0,0,1-.18,0,.19.19,0,0,1-.1-.16A.16.16,0,0,1,128.23,161Zm-1.64-.79a.17.17,0,0,1,.22.1.18.18,0,0,1-.09.22.17.17,0,0,1-.22-.1h0A.18.18,0,0,1,126.59,160.17Zm-1.16.44a.17.17,0,0,1,.21.1.17.17,0,0,1-.31.12h0a.17.17,0,0,1,.1-.22Zm2.33-.88a.17.17,0,0,1,.21.1.17.17,0,0,1-.11.21.16.16,0,0,1-.09-.31Zm-2.79-.34a.17.17,0,0,1,.22.1.16.16,0,0,1-.1.21.15.15,0,0,1-.21-.09s0-.05,0-.07A.15.15,0,0,1,125,159.39Zm1.17-.44a.18.18,0,0,1,.23.07.18.18,0,0,1-.29.2.16.16,0,0,1,0-.23s0,0,0,0Zm1.3-.44a.17.17,0,0,1,.09.16.17.17,0,0,1-.17.16.19.19,0,0,1-.15-.11.17.17,0,0,1,0-.18A.18.18,0,0,1,127.44,158.51Z",
                                                      "data-name":
                                                        "a36cbbbc-d518-47fb-ad06-b682df4fe9ae",
                                                      fill: "#231f20",
                                                      "fill-rule": "evenodd"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "be897636-842f-4c4f-8e99-591e8d953d6b",
                                                "data-name":
                                                  "a3a61583-c32f-408e-b9db-9b719474fe80"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "b6bdec58-5852-4e71-ab18-3a496e9586c8",
                                                  d:
                                                    "M131.25,137.31a1,1,0,0,1,.24.22,1,1,0,0,1,.16.28,1,1,0,0,1,0,.65.27.27,0,0,0,.18.33.33.33,0,0,0,.14,0,.3.3,0,0,0,.19-.19,1.91,1.91,0,0,0,.06-.48,1.66,1.66,0,0,0-.35-.93,1.89,1.89,0,0,0-.37-.32.26.26,0,1,0-.28.44h0",
                                                  "data-name":
                                                    "ea85aceb-843b-41c0-9341-6e3bdaa3ccb8",
                                                  fill: "#fff"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "b5c19b1a-1b41-462d-b76b-d9530185c7ea",
                                                  d:
                                                    "M131.91,136.53a2.12,2.12,0,0,1,.78,2.07.26.26,0,1,0,.52.1,2.65,2.65,0,0,0-1-2.6.26.26,0,1,0-.32.42h0",
                                                  "data-name":
                                                    "a745afdd-fbf7-4162-9869-03530f9a86ad",
                                                  fill: "#fff"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "b792e6e6-7da5-46e5-822e-d874c250ea46",
                                                  d:
                                                    "M132.64,135.72a3.18,3.18,0,0,1,1.13,3,.27.27,0,0,0,.22.31.29.29,0,0,0,.13,0,.26.26,0,0,0,.17-.21,3.72,3.72,0,0,0-1.32-3.5.22.22,0,0,0-.19-.06.29.29,0,0,0-.24.3.25.25,0,0,0,.1.17",
                                                  "data-name":
                                                    "b24b86bd-868e-4fbb-a750-76e7d6111a12",
                                                  fill: "#fff"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "afff1f57-f601-4c63-bfb7-c049391da3d7",
                                                  d:
                                                    "M133.36,134.91a4.27,4.27,0,0,1,1.48,4,.27.27,0,0,0,.24.29.26.26,0,0,0,.28-.22,4.77,4.77,0,0,0-1.67-4.43.26.26,0,0,0-.37.37l0,0",
                                                  "data-name":
                                                    "bad3b8f3-d504-46f1-bdd6-d52f7defa8cb",
                                                  fill: "#fff"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "a4e707ee-220c-499c-80cd-33b95a194285",
                                                  d:
                                                    "M129.73,140.56a1,1,0,0,1-.59,1.25l-5.35,2a1,1,0,0,1-1.26-.56l-1.28-3.45a1,1,0,0,1,.59-1.25l5.35-2a1,1,0,0,1,1.26.56Z",
                                                  "data-name":
                                                    "fd6c16de-a775-4bc7-ad6f-1ec9ca2ad655",
                                                  fill: "#414042"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "bcffdd66-29ca-4dfc-8dac-99e7fdb49161",
                                                  d:
                                                    "M121.6,140.54l-.28-.73a1,1,0,0,1,.59-1.21l1.78-.67a1.16,1.16,0,0,0-.25.29c-.12.39.13.78.45,1.22l.12.19Zm.66,1.76,2.46-.92a2.06,2.06,0,0,0-.17-.88,2.3,2.3,0,0,0-.45-.77l-2.45.92Zm3,.66c-.35-.22-.41-.68-.46-1.22l0-.23-2.44.92.28.74a1,1,0,0,0,1.23.53l1.76-.67A1,1,0,0,1,125.22,143Zm3.42-5-.28-.73a1,1,0,0,0-1.23-.54l-1.74.66a1.32,1.32,0,0,1,.33.08,1.07,1.07,0,0,1,.41.82l-.1,0c-.09-.68-.3-1.06-1.5-.6-2,.76-.4,1.44.12,2.85s-.25,3,1.77,2.22.4-1.45-.12-2.86a3.81,3.81,0,0,1-.22-1Zm-1.75,2.77.15.22c.32.44.57.81.43,1.21a.78.78,0,0,1-.17.26l1.72-.65a1,1,0,0,0,.59-1.21l-.28-.72Zm1.78-2.68-2.46.93a2.25,2.25,0,0,0,.19.88,2.13,2.13,0,0,0,.43.78l2.46-.92Z",
                                                  "data-name":
                                                    "b30bbf42-e8c3-4e24-9894-3ef4de48d74b",
                                                  fill:
                                                    "url(#f1dda938-81e0-4ec1-9eea-3b8a21efc320)",
                                                  "fill-opacity": "0.5"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "ae84c980-fee0-47ca-b8c6-c4aa1ea2d938",
                                                  d:
                                                    "M124.75,137.85a.13.13,0,1,1-.24.08.06.06,0,0,1,0,0,.13.13,0,0,1,.09-.12A.13.13,0,0,1,124.75,137.85Z",
                                                  "data-name":
                                                    "f6ca271f-becd-43b7-8514-6a673d850ee6",
                                                  fill: "#414042"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "bb25b28e-9548-4cd9-94d5-a51b8d1e79d9",
                                                "data-name":
                                                  "ae9d31e9-22b9-4c6b-9faa-9c329adce037"
                                              }
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  id:
                                                    "a3d45048-0154-4cb9-b3d1-8800516f424e",
                                                  "data-name":
                                                    "ede5a742-9e3e-459d-9758-40d0d4d7d3f0",
                                                  fill: "#f26522",
                                                  height: "6.25",
                                                  transform:
                                                    "translate(-38.67 69.05) rotate(-20.63)",
                                                  width: "3.48",
                                                  x: "168.6",
                                                  y: "137.62"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "fa09cf31-3819-441c-bbc3-062d04bcdc3b",
                                                  d:
                                                    "M168.91,141.28a4,4,0,0,1,.32-3.47,4,4,0,1,0,2.2,5.85A4,4,0,0,1,168.91,141.28Z",
                                                  "data-name":
                                                    "e32aa67e-cf47-4211-8c2f-3f8cb36db807",
                                                  fill: "#e52423"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "a97d3b83-095c-47b1-ad26-d576ccf74eba",
                                                  d:
                                                    "M176.88,140.91l0-.12h0v0l-.11.05v0l0,0,0,.12Zm.23-.08-.05-.15h0v.12l-.08-.09,0,0,0,.15,0,0,0-.11.08.08h0v-.11l0,.11Z",
                                                  "data-name":
                                                    "a3bfaec2-074c-49e2-ba1a-a1801d9c2972",
                                                  fill: "#f99f1c"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "f849fcfb-20e0-493c-8b68-f2cdfecb0880",
                                                  d:
                                                    "M176.37,138.47a4,4,0,0,1-4.93,5.2,4,4,0,0,0-1.33-5.46,4.53,4.53,0,0,0-.87-.39,4,4,0,0,1,5.46-1.35A4,4,0,0,1,176.37,138.47Z",
                                                  "data-name":
                                                    "b6d47582-1d4e-4211-ac4a-1eea17a89ebc",
                                                  fill: "#f99f1c"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "a6cca760-2e27-422a-ac79-bcfb97a587fe",
                                                "data-name":
                                                  "a51eb1bb-28f6-47d5-8731-be1a0b4b4c8e"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "e4bf9e0f-a65b-4caf-aac2-ffb89b7da0e7",
                                                  d:
                                                    "M150.57,133l17.53-6.6a11.7,11.7,0,0,0-1.68-1.88,5.84,5.84,0,0,0-5.9-1.15l-9,3.39Z",
                                                  "data-name":
                                                    "ab89325c-3d95-4b5f-b234-253613f1c6a5",
                                                  fill:
                                                    "url(#ac913104-fd4b-4160-86b0-344b25cb451b)"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "e6f105d7-89d7-4d4c-8e92-9311e94656cb",
                                                  d:
                                                    "M161.22,109.6l8.52,7.2,2.92,7.74a5.61,5.61,0,0,1-4.23-.78l-.06-.05-9-7.64-1.22,8.21-.52,3.5c-.32,1.91-1.7,3.23-4,4.1l-3,1.14.94-6.24.72-4.81h0l.17-1.1,1.27-8.43Z",
                                                  "data-name":
                                                    "af523ff0-8073-4614-a796-17492b6a543f",
                                                  fill:
                                                    "url(#b9e89fef-a341-47e7-9d61-17f3a62b9ac0)"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "a5f1ed73-a1c7-4fef-8753-b6813e74a34d",
                                                  d:
                                                    "M161.22,109.6l8.52,7.2,2.92,7.75a5.66,5.66,0,0,1-4.23-.79l-.06,0-9-7.64c-3.22-2.66-6.36.87-6.95,4.77h0l1.27-8.41Z",
                                                  "data-name":
                                                    "ad271562-437c-4dd1-8a2d-2d55419fbe55",
                                                  fill:
                                                    "url(#a038a928-f4e0-48cb-984d-c8b44cbefd00)"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "fc2653ae-b23f-475f-981c-c9803835e1e3",
                                                "data-name":
                                                  "e69a3d04-1494-496b-9959-fe37bd632452"
                                              }
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "bf63ef26-7fc1-4090-b809-33970b52628c",
                                                    "data-name":
                                                      "a5875fb6-5a24-4b62-813a-1340cc3cc59f"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "fb442046-1d3c-4fbd-9fec-3fa2c0b161f7",
                                                      d:
                                                        "M136.41,128.26l2.39-.9a1.38,1.38,0,0,0-.23-.26.8.8,0,0,0-.8-.15l-1.23.46Z",
                                                      "data-name":
                                                        "bcef0181-0c7b-49e7-92eb-c9740ffc8a13",
                                                      fill:
                                                        "url(#b554cf5f-e7e9-41d3-9ba4-1271329ca92d)"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "a2e95035-729b-4c99-9a04-d0748a8fd68c",
                                                      d:
                                                        "M136.66,126.6h0l0,.15h0l-.1.66-.12.85.41-.16a.74.74,0,0,0,.54-.56l.07-.47.17-1.12,1.23,1a.83.83,0,0,0,.78.06l.41-.15-3-2.56Z",
                                                      "data-name":
                                                        "acc82ba8-cc8a-4ca3-850b-aa78b2564d7f",
                                                      fill:
                                                        "url(#a94d4f39-8c42-4a0e-93a9-0e812c36b2eb)"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "bd3cb8b4-67c8-4cd6-b111-b8c3dd388a3b",
                                                      d:
                                                        "M136.66,126.6c.08-.53.51-1,1-.65l1.23,1a.83.83,0,0,0,.78.06l.41-.15-3-2.56Z",
                                                      "data-name":
                                                        "b5a7abce-9fa4-492d-a200-09ec1936c5a5",
                                                      fill:
                                                        "url(#bce63e68-b62a-4192-9d6a-6e109aabc159)"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("polygon", {
                                                attrs: {
                                                  id:
                                                    "ae575764-295e-43ba-b05b-ecd6e9e585e5",
                                                  "data-name":
                                                    "b0f74388-d854-425b-9f73-54ed5ad64d4c",
                                                  fill: "#fff",
                                                  points:
                                                    "131.57 128.57 131.27 129.3 131.58 130.13 130.97 130.36 129.74 127.1 130.35 126.87 130.98 128.53 131.96 126.26 132.64 126 131.82 127.98 133.94 129.23 133.23 129.5 131.57 128.57"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "ef01e2a7-bc65-4689-b825-00c6c6fa87f7",
                                                  d:
                                                    "M121.5,131.08a1.7,1.7,0,0,0-.85-.36,1.93,1.93,0,0,0-1,.12h0a1.92,1.92,0,0,0-.82.55,1.69,1.69,0,0,0-.4.84,1.88,1.88,0,0,0,.64,1.72,1.79,1.79,0,0,0,.85.36,2,2,0,0,0,1-.12h0a2.16,2.16,0,0,0,.81-.55,1.69,1.69,0,0,0,.4-.84,1.86,1.86,0,0,0-.65-1.72Zm0,1.64a1.26,1.26,0,0,1-.26.56,1.38,1.38,0,0,1-.53.37h0a1.31,1.31,0,0,1-.65.07,1.19,1.19,0,0,1-.56-.25,1.32,1.32,0,0,1-.44-1.18,1.14,1.14,0,0,1,.25-.56,1.28,1.28,0,0,1,.53-.37h0a1.28,1.28,0,0,1,.64-.07,1.18,1.18,0,0,1,.57.25A1.33,1.33,0,0,1,121.52,132.72Z",
                                                  "data-name":
                                                    "ea70296a-e29c-4316-957f-fbd057fa0c8e",
                                                  fill: "#fff"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "bd1d9b9b-6d0e-436d-b2ad-df761b8d6828",
                                                  d:
                                                    "M127,130.65a1.07,1.07,0,0,0,.36-.59,1.28,1.28,0,0,0,0-.7,1.21,1.21,0,0,0-.41-.56,1.16,1.16,0,0,0-.62-.22,2.12,2.12,0,0,0-.79.13l-1.34.51,1.22,3.24.6-.23-1-2.73.71-.27a1,1,0,0,1,.67,0,.71.71,0,0,1,.37.92v0a.94.94,0,0,1-.54.4l-.1,0,.19.5.25-.1,1,.69.65-.24Z",
                                                  "data-name":
                                                    "f67f4c64-cadf-4f8f-ba7a-1a505f25a426",
                                                  fill: "#fff"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-image", {
                                    attrs: {
                                      "aspect-ratio": 1,
                                      tiny: {
                                        default: require("@/images/gold/carousel/globe.png"),
                                        retina: require("@/images/gold/carousel/globe@2.png")
                                      },
                                      alt: "todo fill alt"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  ref: "carouselVisualPayments",
                                  staticClass:
                                    "carousel__visual carousel__visual--svg"
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        viewBox: "0 0 383 380",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink"
                                      }
                                    },
                                    [
                                      _c(
                                        "defs",
                                        [
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "ac1eb1db-a026-46b8-8ec2-eedc30bcba56",
                                                gradientTransform:
                                                  "translate(-74.3 77.73) rotate(-18.07)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "170.31",
                                                x2: "170.31",
                                                y1: "253.83",
                                                y2: "251.31"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#6d6e71"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.28",
                                                  "stop-color": "#f6f6f6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.29",
                                                  "stop-color": "#e5e6e6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.34",
                                                  "stop-color": "#c0c1c3"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.38",
                                                  "stop-color": "#a3a5a7"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.43",
                                                  "stop-color": "#8f9093"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.47",
                                                  "stop-color": "#828487"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.52",
                                                  "stop-color": "#7e8083"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.54",
                                                  "stop-color": "#86888b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.59",
                                                  "stop-color": "#9b9d9f"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.64",
                                                  "stop-color": "#bebfc1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.7",
                                                  "stop-color": "#efefef"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.72",
                                                  "stop-color": "#fff"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#5a5b5d"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "bf0d6376-9bb3-4bf4-9569-9da34fc9c63c",
                                                gradientTransform:
                                                  "translate(88497.16 -14185.83) rotate(-18.07) scale(102.79 30.24)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "-860.32",
                                                x2: "-860.18",
                                                y1: "-451.57",
                                                y2: "-451.57"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#523613"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.13",
                                                  "stop-color": "#302011"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.18",
                                                  "stop-color": "#3b2613"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.23",
                                                  "stop-color": "#4a3013"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.32",
                                                  "stop-color": "#6a4610"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.38",
                                                  "stop-color": "#7d5c22"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.47",
                                                  "stop-color": "#a6813d"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.62",
                                                  "stop-color": "#b68d45"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.64",
                                                  "stop-color": "#c6a350"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.67",
                                                  "stop-color": "#ddc05f"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.69",
                                                  "stop-color": "#e6cc65"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.79",
                                                  "stop-color": "#fdfadb"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.85",
                                                  "stop-color": "#fdfadb"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.92",
                                                  "stop-color": "#bb9f5a"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#87601c"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "f24abdd8-7e6e-4ee2-873f-0a00f0f6cc10",
                                                gradientTransform:
                                                  "translate(121381.94 10954.44) rotate(-18.07) scale(129.8 99.62)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "-862.01",
                                                x2: "-862.07",
                                                y1: "-479.41",
                                                y2: "-479.35"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#87601c"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.29",
                                                  "stop-color": "#ffea86"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.37",
                                                  "stop-color": "#fdef89"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.4",
                                                  "stop-color": "#fcf18b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.41",
                                                  "stop-color": "#fbec83"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.52",
                                                  "stop-color": "#eece54"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.63",
                                                  "stop-color": "#ffea86"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.73",
                                                  "stop-color": "#fdef89"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.76",
                                                  "stop-color": "#fcf18b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.81",
                                                  "stop-color": "#dac065"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.94",
                                                  "stop-color": "#945e22"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#7c3e11"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "fb07e921-d3b5-4bf4-a879-41f06a5c7bd1",
                                                gradientTransform:
                                                  "translate(94079.93 19455.06) rotate(-18.07) scale(96.85 98.84)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "-860.12",
                                                x2: "-859.98",
                                                y1: "-479.38",
                                                y2: "-479.25"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#87601c"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.11",
                                                  "stop-color": "#ffea86"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.24",
                                                  "stop-color": "#fdef89"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.27",
                                                  "stop-color": "#fcf18b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.3",
                                                  "stop-color": "#fbec83"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.5",
                                                  "stop-color": "#eece54"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.57",
                                                  "stop-color": "#ffea86"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.72",
                                                  "stop-color": "#fdef89"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.76",
                                                  "stop-color": "#fcf18b"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.81",
                                                  "stop-color": "#dac065"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0.94",
                                                  "stop-color": "#945e22"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#7c3e11"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "b006f3f2-cf73-4a77-9c4d-8b64cff284c7",
                                              gradientTransform:
                                                "matrix(13.32, -4.34, 1.28, 3.92, 11112.59, -2489.75)",
                                              x1: "-802.86",
                                              x2: "-802.72",
                                              "xlink:href":
                                                "#bf0d6376-9bb3-4bf4-9569-9da34fc9c63c",
                                              y1: "-189.84",
                                              y2: "-189.84"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "b58f51ca-3728-4f51-a31d-ef6fee9682a0",
                                              gradientTransform:
                                                "translate(19330 2511.49) rotate(-18.07) scale(21.22 18.98)",
                                              x1: "-825.07",
                                              x2: "-825.13",
                                              "xlink:href":
                                                "#f24abdd8-7e6e-4ee2-873f-0a00f0f6cc10",
                                              y1: "-426.01",
                                              y2: "-425.93"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "e84e8c37-3714-4e10-909e-0e61014d2f50",
                                              gradientTransform:
                                                "translate(15620.39 3721.58) rotate(-18.07) scale(16.72 18.98)",
                                              x1: "-813.8",
                                              x2: "-813.69",
                                              "xlink:href":
                                                "#fb07e921-d3b5-4bf4-a879-41f06a5c7bd1",
                                              y1: "-426.08",
                                              y2: "-425.95"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "linearGradient",
                                            {
                                              attrs: {
                                                id:
                                                  "ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                                gradientTransform:
                                                  "matrix(19.2, 0, 0, -19.2, 9198.27, 11097.47)",
                                                gradientUnits: "userSpaceOnUse",
                                                x1: "-464.95",
                                                x2: "-463.95",
                                                y1: "563.2",
                                                y2: "562.2"
                                              }
                                            },
                                            [
                                              _c("stop", {
                                                attrs: {
                                                  offset: "0",
                                                  "stop-color": "#f8f1c3"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("stop", {
                                                attrs: {
                                                  offset: "1",
                                                  "stop-color": "#e3c963"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "a7f8c06f-b184-4ad5-9b40-784e2bb4dd82",
                                              gradientTransform:
                                                "matrix(9.6, 0, 0, -9.6, 4491.02, 5585.85)",
                                              x1: "-439.07",
                                              x2: "-438.05",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "551.78",
                                              y2: "550.77"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "b3069ab3-8534-4e49-9f80-f588ad6e076b",
                                              gradientTransform:
                                                "matrix(35.2, 0, 0, -35.2, 17043.69, 20283.5)",
                                              x1: "-476.72",
                                              x2: "-475.71",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "568.4",
                                              y2: "567.39"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "b3b016e8-dbf2-4a99-9ab2-3e35566d11a0",
                                              gradientTransform:
                                                "matrix(51.2, 0, 0, -51.2, 24889.12, 29469.54)",
                                              x1: "-481.13",
                                              x2: "-480.13",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "570.35",
                                              y2: "569.34"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "a1536304-349a-4699-a4a8-cbfdc089bd2e",
                                              gradientTransform:
                                                "matrix(60, 0, 0, -60, 29174.5, 34305.25)",
                                              x1: "-482.57",
                                              x2: "-481.55",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "571.04",
                                              y2: "570.03"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "faa75c04-3476-4937-b704-e7ac0758b065",
                                              gradientTransform:
                                                "matrix(60, 0, 0, -60, 29174.5, 34305.25)",
                                              x1: "-482.56",
                                              x2: "-481.56",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "571.03",
                                              y2: "570.03"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "a1fab673-ffbb-48ff-af3e-2d6285600787",
                                              gradientTransform:
                                                "matrix(80, 0, 0, -80, 38981.28, 45787.8)",
                                              x1: "-484.63",
                                              x2: "-483.63",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "571.93",
                                              y2: "570.93"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "ed561c86-fb10-44d1-9abb-a67bfc08486e",
                                              gradientTransform:
                                                "matrix(100, 0, 0, -100, 48788.06, 57270.34)",
                                              x1: "-485.87",
                                              x2: "-484.87",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "572.47",
                                              y2: "571.47"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "f77690e5-74b2-484a-b3f1-fd0b3dc63173",
                                              gradientTransform:
                                                "matrix(60, 0, 0, -60, 29064.5, 34501.25)",
                                              x1: "-482.58",
                                              x2: "-481.56",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "570.98",
                                              y2: "569.96"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "a08b30f9-909e-49dc-bef1-95d6d07d7cdf",
                                              gradientTransform:
                                                "matrix(60, 0, 0, -60, 29064.5, 34501.25)",
                                              x1: "-482.57",
                                              x2: "-481.57",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "570.97",
                                              y2: "569.97"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "a100c7cb-2670-4d71-a661-5d65e7145eda",
                                              gradientTransform:
                                                "matrix(80, 0, 0, -80, 38871.28, 45983.8)",
                                              x1: "-484.64",
                                              x2: "-483.63",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "571.89",
                                              y2: "570.89"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "e1219542-7397-4c44-9871-4b4ca756b7c8",
                                              gradientTransform:
                                                "matrix(100, 0, 0, -100, 48678.06, 57466.34)",
                                              x1: "-485.88",
                                              x2: "-484.87",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "572.44",
                                              y2: "571.43"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "ea6028c8-cba8-4de6-8d75-b4fc440a46c3",
                                              gradientTransform:
                                                "matrix(60, 0, 0, -60, 28990.5, 34375.25)",
                                              x1: "-482.58",
                                              x2: "-481.57",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "571.01",
                                              y2: "570"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "b1107e64-9965-460d-937f-9074397f82d2",
                                              gradientTransform:
                                                "matrix(60, 0, 0, -60, 28990.5, 34375.25)",
                                              x1: "-482.58",
                                              x2: "-481.57",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "571",
                                              y2: "570"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "bc5384f4-3a01-4ba7-9933-eba93d8026c2",
                                              gradientTransform:
                                                "matrix(80, 0, 0, -80, 38797.28, 45857.8)",
                                              x1: "-484.65",
                                              x2: "-483.64",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "571.92",
                                              y2: "570.91"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("linearGradient", {
                                            attrs: {
                                              id:
                                                "b8ad1d61-26d1-4c65-9db7-9ab0931650e3",
                                              gradientTransform:
                                                "matrix(100, 0, 0, -100, 48604.06, 57340.34)",
                                              x1: "-485.88",
                                              x2: "-484.88",
                                              "xlink:href":
                                                "#ab3168a4-7b0f-4966-88f8-ee228a8166d8",
                                              y1: "572.46",
                                              y2: "571.45"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id:
                                              "a3f646bd-ea41-44db-b72f-4c3a716c6ca0",
                                            "data-name": "Vrstva 1"
                                          }
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "b61a20b7-8699-409f-ae03-99d4b1b9b1c4",
                                                "data-name": "lines"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "b9a19929-1d59-4ba0-9ae3-44e31bf7150f",
                                                  d:
                                                    "M251,74.46q68.22-3.45,97.23,5.12t9.07,20.09",
                                                  "data-name": "line-1",
                                                  fill: "none",
                                                  stroke: "#fff",
                                                  "stroke-dasharray": "0 6",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  "stroke-width": "2"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "ea660673-306e-4959-9a52-b301412ddb90",
                                                  d:
                                                    "M65.88,144.83Q135.32,95,251,73",
                                                  "data-name": "line-2",
                                                  fill: "none",
                                                  stroke: "#fff",
                                                  "stroke-dasharray": "0 6",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  "stroke-width": "2"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "e838a92e-aa4d-4d42-83ee-7af71212e7f9",
                                                  d:
                                                    "M17,111.75q-17.38-4.52-7,15.55,25.64,52.28,131.7,141.29",
                                                  "data-name": "line-3",
                                                  fill: "none",
                                                  stroke: "#fff",
                                                  "stroke-dasharray": "0 6",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  "stroke-width": "2"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  id:
                                                    "b018abf6-348c-4de4-b9c2-2d48612a0153",
                                                  d:
                                                    "M140.35,271.15q48-17.55,83.18-11.94T281,293.62",
                                                  "data-name": "line-4",
                                                  fill: "none",
                                                  stroke: "#fff",
                                                  "stroke-dasharray": "0 6",
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "b45be8ec-7822-40d7-b632-5cde165d2d09",
                                                "data-name": "card"
                                              }
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "a2ab91cf-803b-4c48-be30-01bc4b598984",
                                                    "data-name":
                                                      "b6d790e3-39ce-4026-a312-ca792fb3e41a"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "b3b95e00-6584-4c6a-8533-894312b43c34",
                                                      d:
                                                        "M158.41,253.25l40.47-13.33a3.87,3.87,0,0,1,4.9,2.51l7.82,24.22a3.93,3.93,0,0,1-2.49,5l-40.47,13.34a3.89,3.89,0,0,1-4.9-2.52l-7.82-24.22A3.93,3.93,0,0,1,158.41,253.25Z",
                                                      "data-name":
                                                        "b274c2ac-b9cb-417f-9f0c-3a4b70ddf97b",
                                                      fill: "#222226"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "a7efdf7f-96d9-4d44-bca5-948c9eef482c",
                                                        "data-name":
                                                          "b1673a7a-62c2-4d60-b5df-86d3cb85dc05"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "b3d9cd94-4b1b-4380-b69b-1758a24be19b",
                                                          d:
                                                            "M165.83,274.21a12.19,12.19,0,0,1,15,6.7l-.12,0a12.07,12.07,0,0,0-16-6.15,12.42,12.42,0,0,0-2.77,1.74l0-.13A12.06,12.06,0,0,1,165.83,274.21Zm-.32-1a13.22,13.22,0,0,1,16.25,7.36l-.12.05a13.08,13.08,0,0,0-17.32-6.79,13.31,13.31,0,0,0-2.76,1.66l-.05-.15A13.07,13.07,0,0,1,165.51,273.23Zm-.31-1a14.23,14.23,0,0,1,17.53,8l-.13,0a14.05,14.05,0,0,0-21.37-5.84l0-.13A14,14,0,0,1,165.2,272.26Zm-.32-1A15.24,15.24,0,0,1,183.7,280l-.13,0a15.1,15.1,0,0,0-19.87-8.11,14.78,14.78,0,0,0-2.8,1.57l-.05-.13A15.11,15.11,0,0,1,164.88,271.29Zm-.31-1a16.27,16.27,0,0,1,20.1,9.32l-.13,0a16.11,16.11,0,0,0-21.15-8.77,15.72,15.72,0,0,0-2.82,1.54l0-.13A16.54,16.54,0,0,1,164.57,270.31Zm-.32-1a17.28,17.28,0,0,1,21.39,10l-.13,0a17.09,17.09,0,0,0-25.27-7.92l0-.14A17,17,0,0,1,164.25,269.34Zm-.31-1A18.29,18.29,0,0,1,186.59,279l-.12,0A18.15,18.15,0,0,0,162.71,269a18.46,18.46,0,0,0-2.79,1.45l0-.13A18.17,18.17,0,0,1,163.94,268.38Zm-.31-1a19.29,19.29,0,0,1,23.94,11.28l-.12,0a19.13,19.13,0,0,0-27.86-9.3l0-.13A19.14,19.14,0,0,1,163.63,267.4Zm-.32-1a20.32,20.32,0,0,1,25.22,11.94l-.12,0A20.16,20.16,0,0,0,162.13,267a19.52,19.52,0,0,0-2.86,1.42l0-.13A20.6,20.6,0,0,1,163.31,266.42Zm-.31-1A21.32,21.32,0,0,1,189.5,278l-.13,0A21.17,21.17,0,0,0,161.81,266a21.68,21.68,0,0,0-2.86,1.41l0-.14A21.49,21.49,0,0,1,163,265.45Zm-.32-1a22.33,22.33,0,0,1,27.79,13.24l-.13,0a22.2,22.2,0,0,0-28.89-12.67,21.5,21.5,0,0,0-2.82,1.36l0-.15A21.72,21.72,0,0,1,162.68,264.48Zm-.31-1a23.34,23.34,0,0,1,29.06,13.9l-.12,0a23.2,23.2,0,0,0-30.13-13.36,22.76,22.76,0,0,0-2.87,1.36l-.05-.13A23.12,23.12,0,0,1,162.37,263.5Zm-.32-1a24.36,24.36,0,0,1,30.36,14.56l-.14.05a24.2,24.2,0,0,0-31.4-14,25.17,25.17,0,0,0-2.88,1.35l-.05-.13A24.94,24.94,0,0,1,162.05,262.52Zm-.32-1a25.43,25.43,0,0,1,31.68,15.24l-.13,0a25.26,25.26,0,0,0-32.74-14.71,26,26,0,0,0-2.89,1.33l0-.13A25.83,25.83,0,0,1,161.73,261.51Zm-.32-1a26.43,26.43,0,0,1,33,15.89l-.12.05a26.27,26.27,0,0,0-34-15.37,25.12,25.12,0,0,0-2.89,1.32l-.05-.13A27.15,27.15,0,0,1,161.41,260.54Zm-.31-1a27.44,27.44,0,0,1,34.24,16.55l-.13,0a27.29,27.29,0,0,0-35.3-16,26.88,26.88,0,0,0-2.89,1.31l-.05-.13A27.16,27.16,0,0,1,161.1,259.57Zm-.32-1a28.46,28.46,0,0,1,35.53,17.2l-.14,0a28.31,28.31,0,0,0-35.34-17.11,27.11,27.11,0,0,0-4.13,1.73l0-.13A27.43,27.43,0,0,1,160.78,258.6Zm-.31-1a29.48,29.48,0,0,1,36.8,17.86l-.12,0a29.26,29.26,0,0,0-40.77-16l0-.13A29.25,29.25,0,0,1,160.47,257.62Zm-.33-1a30.53,30.53,0,0,1,38.13,18.53l-.13,0a30.39,30.39,0,0,0-38-18.44,29.64,29.64,0,0,0-4.13,1.7l0-.13A30.15,30.15,0,0,1,160.14,256.62Zm-.31-1a31.55,31.55,0,0,1,39.41,19.19l-.13,0a31.41,31.41,0,0,0-39.24-19.1,31,31,0,0,0-4.05,1.66v-.15A33.52,33.52,0,0,1,159.83,255.64Zm-.32-1a32.59,32.59,0,0,1,40.73,19.86l-.13,0a32.45,32.45,0,0,0-40.56-19.77,32,32,0,0,0-3.66,1.45,1.36,1.36,0,0,1,0-.17A32.44,32.44,0,0,1,159.51,254.64Z",
                                                          "data-name":
                                                            "ea33dded-e609-4f59-a3e0-f8608158c426",
                                                          fill: "#302e2f"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "a3be191a-f69a-42cd-853a-46685390f9b3",
                                                          d:
                                                            "M209.45,260l.1.31a22.61,22.61,0,0,1-11.23.41,23,23,0,0,1-16.86-15l.1,0A22.81,22.81,0,0,0,209.45,260Zm-.23-.7,0,.09a22.14,22.14,0,0,1-27.08-14l.08,0A22.07,22.07,0,0,0,209.22,259.28Zm-.22-.68,0,.09a21.43,21.43,0,0,1-26.18-13.49l.09,0A21.37,21.37,0,0,0,209,258.6Zm-.23-.7,0,.08a20.7,20.7,0,0,1-25.25-13l.09,0a20.63,20.63,0,0,0,25.13,13Zm-.22-.7.1.3a20,20,0,0,1-24.43-12.76l.1,0a19.92,19.92,0,0,0,24.23,12.49Zm-.22-.68.09.29a19.26,19.26,0,0,1-23.52-12.29l.1,0a19.21,19.21,0,0,0,23.33,12Zm-.22-.69.09.29a18.56,18.56,0,0,1-22.62-11.82l.09,0a18.49,18.49,0,0,0,22.44,11.57Zm-.22-.68,0,.09a17.86,17.86,0,0,1-21.66-11.17l.09,0a17.78,17.78,0,0,0,21.54,11.11Zm-.23-.71.09.27a17,17,0,0,1-8.23.26A17.2,17.2,0,0,1,187,243.84l.1,0a17,17,0,0,0,20.6,10.63Zm-.22-.69.08.27a16.34,16.34,0,0,1-19.88-10.4l.1,0A16.34,16.34,0,0,0,207.44,253.75Zm-.22-.68.08.26a15.56,15.56,0,0,1-7.49.22,15.76,15.76,0,0,1-11.49-10.16l.1,0A15.62,15.62,0,0,0,207.22,253.07Zm-.23-.69.09.27a14.79,14.79,0,0,1-7.12.19,15,15,0,0,1-11-9.67l.1,0A14.9,14.9,0,0,0,207,252.38Zm-.22-.68.09.26a14.25,14.25,0,0,1-17.18-9l.09,0a14.19,14.19,0,0,0,17,8.79Zm-.22-.69.08.26a13.45,13.45,0,0,1-6.37.16,13.62,13.62,0,0,1-9.9-8.71l.09,0a13.48,13.48,0,0,0,16.1,8.32Zm-.22-.68.08.25A12.84,12.84,0,0,1,191,242.5l.1,0a12.77,12.77,0,0,0,15.2,7.86Zm-10-2.4a12.07,12.07,0,0,0,9.79,1.65l0,.07a12,12,0,0,1-9.94-1.8l0,0Zm9.59,1,.1.3a11.41,11.41,0,0,1-13.6-7.2l.1,0A11.35,11.35,0,0,0,205.89,249Zm-.22-.69.07.24a10.63,10.63,0,0,1-4.89.08,10.76,10.76,0,0,1-7.78-6.76l.1,0a10.64,10.64,0,0,0,12.5,6.48Zm-.22-.68,0,.09a10,10,0,0,1-11.71-6.08l.09,0A9.93,9.93,0,0,0,205.45,247.59Zm-.23-.7,0,.1a9.3,9.3,0,0,1-10.82-5.61l.1,0A9.2,9.2,0,0,0,205.22,246.89Zm-.22-.68.07.23a8.57,8.57,0,0,1-10-5.28l.11,0A8.49,8.49,0,0,0,205,246.21Zm-8.86,1.62a12.19,12.19,0,0,1-4.41-5.56l.08,0a12.13,12.13,0,0,0,4.21,5.5l.13.09Z",
                                                          "data-name":
                                                            "a05d1805-33ea-4e0b-9435-b7fc655dced5",
                                                          fill: "#231f20"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "e016891b-21e5-4e76-a3c4-ffdb77c625cc",
                                                          d:
                                                            "M188,273.41a7.61,7.61,0,0,1,5.66,3.28l0,0a7.52,7.52,0,0,0-10.56-1.85,7.68,7.68,0,0,0-3.21,6.38l-.07,0a7.68,7.68,0,0,1,7.46-7.88c.26,0,.51,0,.77,0Zm-2.81.81a7.13,7.13,0,0,1,8,2.62h-.06a7.08,7.08,0,0,0-10-1.54,7.21,7.21,0,0,0-2.89,5.24,5.24,5.24,0,0,0,0,.56h-.05A7.22,7.22,0,0,1,185.2,274.22Zm2.74.11a6.71,6.71,0,0,1,4.83,2.66h0a6.65,6.65,0,0,0-9.38-1.25,6.8,6.8,0,0,0-2.61,5.2l-.06,0a6.77,6.77,0,0,1,6.87-6.66Zm-2.46.74a6.25,6.25,0,0,1,6.85,2.06l-.06,0a6.19,6.19,0,0,0-8.77-.94,6.31,6.31,0,0,0-2.29,4.41c0,.06,0,.12,0,.18l0,0A6.34,6.34,0,0,1,185.48,275.07Zm2.39.16a5.84,5.84,0,0,1,4,2l-.05,0a5.76,5.76,0,0,0-8.17-.63,5.88,5.88,0,0,0-2,4l-.05,0a5.94,5.94,0,0,1,.62-2.23A5.81,5.81,0,0,1,187.87,275.23Zm0,.45a5.35,5.35,0,0,1,3.57,1.76h-.05a5.31,5.31,0,0,0-7.55-.31,5.46,5.46,0,0,0-1.69,3.36l-.05,0a5.4,5.4,0,0,1,5.78-4.84Z",
                                                          "data-name":
                                                            "fc3624dc-d130-4ca1-8f86-962be4fcf1da",
                                                          fill: "#231f20"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "bda95b46-db73-43c2-992b-212ad4313606",
                                                          d:
                                                            "M171.74,256a17.76,17.76,0,0,1-13.42,9.62l0-.06a18.68,18.68,0,0,0,3.13-.72,17.83,17.83,0,0,0,12.17-16.61l.07,0A18,18,0,0,1,171.74,256Zm-.45-.38-.06.12a17,17,0,0,1-10,8.61,17.75,17.75,0,0,1-3.13.72l0-.07a16.88,16.88,0,0,0,3.13-.71A17.23,17.23,0,0,0,173,248.43l.08,0A17.28,17.28,0,0,1,171.29,255.63Zm-.55-.13a16.53,16.53,0,0,1-9.64,8.33,16.11,16.11,0,0,1-3.13.71l0-.07a16,16,0,0,0,3.14-.7,16.67,16.67,0,0,0,11.38-15.15l.08,0A16.8,16.8,0,0,1,170.74,255.5Zm-.51-.26a15.91,15.91,0,0,1-9.31,8,15.1,15.1,0,0,1-3.13.7l0-.06a16,16,0,0,0,14.11-15.11l.08,0A16.18,16.18,0,0,1,170.23,255.24Zm-.49-.25a15.47,15.47,0,0,1-9,7.77,16,16,0,0,1-3.14.68l0-.06a14.88,14.88,0,0,0,3.15-.68A15.54,15.54,0,0,0,171.32,249l.07,0A15.58,15.58,0,0,1,169.74,255Zm-.49-.26a14.84,14.84,0,0,1-8.67,7.5,14.62,14.62,0,0,1-3.14.66l0-.06a14.25,14.25,0,0,0,3.15-.66,15,15,0,0,0,10.19-13l.06,0A15,15,0,0,1,169.25,254.73Z",
                                                          "data-name":
                                                            "f2489913-98c0-4300-8dc2-6955e6df0ca4",
                                                          fill: "#231f20"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "af5ec585-479d-42ba-837a-bf44779a654a",
                                                          d:
                                                            "M165.6,284.32a.15.15,0,0,1,.18.1.15.15,0,0,1,0,.15.14.14,0,0,1-.16,0,.12.12,0,0,1-.08-.14A.14.14,0,0,1,165.6,284.32Zm1-.33a.14.14,0,0,1,.19.09.15.15,0,0,1-.05.15.15.15,0,0,1-.16,0,.15.15,0,0,1-.07-.15.14.14,0,0,1,.09-.12Zm1-.34a.15.15,0,0,1,.18.09.14.14,0,0,1-.2.18.14.14,0,0,1-.08-.15A.14.14,0,0,1,167.65,283.65Zm-1.38-.75a.15.15,0,0,1,.18.09.14.14,0,0,1-.09.19.14.14,0,0,1-.18-.09h0A.14.14,0,0,1,166.27,282.9Zm-1,.34a.15.15,0,0,1,.09.28.15.15,0,0,1-.18-.1h0a.15.15,0,0,1,.1-.18h0Zm2-.67a.13.13,0,0,1,.18.09.14.14,0,0,1-.11.17.14.14,0,0,1-.16-.08.16.16,0,0,1,.1-.19Zm-2.39-.41a.13.13,0,0,1,.18.09.14.14,0,0,1-.09.18.13.13,0,0,1-.18-.09.13.13,0,0,1,0-.06A.12.12,0,0,1,164.9,282.16Zm1-.34a.13.13,0,0,1,.19.07.13.13,0,0,1-.05.18.14.14,0,1,1-.18-.22l0,0Zm1.14-.33a.15.15,0,0,1,.08.14.15.15,0,0,1-.16.13.14.14,0,0,1-.12-.1.12.12,0,0,1,0-.15A.13.13,0,0,1,167.06,281.49Z",
                                                          "data-name":
                                                            "a36cbbbc-d518-47fb-ad06-b682df4fe9ae",
                                                          fill: "#231f20",
                                                          "fill-rule": "evenodd"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "b94659ba-a9e3-4140-bab9-d7d817a379d4",
                                                    "data-name":
                                                      "a3a61583-c32f-408e-b9db-9b719474fe80"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "fa7d337d-a8eb-46ad-9edd-4c30cc7113d7",
                                                      d:
                                                        "M171.17,263.15a.9.9,0,0,1,.33.46.89.89,0,0,1,0,.56.23.23,0,0,0,.15.29.17.17,0,0,0,.12,0,.23.23,0,0,0,.17-.15,1.54,1.54,0,0,0,.07-.42,1.32,1.32,0,0,0-.27-.82,1.07,1.07,0,0,0-.3-.3.23.23,0,1,0-.26.37h0",
                                                      "data-name":
                                                        "ea85aceb-843b-41c0-9341-6e3bdaa3ccb8",
                                                      fill: "#fff"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "acbda611-af77-4259-8293-f57c3b590748",
                                                      d:
                                                        "M171.77,262.5a1.86,1.86,0,0,1,.59,1.83.23.23,0,0,0,.17.28.24.24,0,0,0,.28-.17,2.32,2.32,0,0,0-.75-2.3.23.23,0,0,0-.29.35h0",
                                                      "data-name":
                                                        "a745afdd-fbf7-4162-9869-03530f9a86ad",
                                                      fill: "#fff"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "ba03b41d-f680-477a-939a-1328b856a62a",
                                                      d:
                                                        "M172.43,261.82a2.8,2.8,0,0,1,.86,2.66.23.23,0,0,0,.17.28.17.17,0,0,0,.12,0,.23.23,0,0,0,.16-.17,3.26,3.26,0,0,0-1-3.1.19.19,0,0,0-.16-.06.24.24,0,0,0-.22.25.19.19,0,0,0,.08.15",
                                                      "data-name":
                                                        "b24b86bd-868e-4fbb-a750-76e7d6111a12",
                                                      fill: "#fff"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "ac4fca45-27f2-498b-9a64-3c69da8bebd3",
                                                      d:
                                                        "M173.08,261.15a3.73,3.73,0,0,1,1.13,3.49.23.23,0,0,0,.45.09,4.21,4.21,0,0,0-1.27-3.93.24.24,0,0,0-.33,0,.25.25,0,0,0,0,.33l0,0",
                                                      "data-name":
                                                        "bad3b8f3-d504-46f1-bdd6-d52f7defa8cb",
                                                      fill: "#fff"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "a935ba78-7b5a-4a87-8c33-897f5984ba07",
                                                      d:
                                                        "M169.73,265.93a.85.85,0,0,1-.56,1.06l-4.69,1.52a.85.85,0,0,1-1.07-.53l-1-3.07a.86.86,0,0,1,.56-1.06l4.7-1.52a.84.84,0,0,1,1.06.53Z",
                                                      "data-name":
                                                        "fd6c16de-a775-4bc7-ad6f-1ec9ca2ad655",
                                                      fill: "#414042"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "f977c9ff-c4c0-45c0-8db2-ed43d49416d0",
                                                      d:
                                                        "M162.71,265.59l-.2-.64a.84.84,0,0,1,.55-1l1.56-.51a1,1,0,0,0-.22.24c-.12.34.08.69.34,1.09l.09.16Zm.51,1.57,2.16-.72a2,2,0,0,0-.12-.77,1.83,1.83,0,0,0-.36-.69l-2.15.71Zm2.53.68c-.3-.2-.33-.61-.35-1.08,0-.07,0-.13,0-.2l-2.14.71.21.65a.82.82,0,0,0,1,.51l1.55-.51A.74.74,0,0,1,165.75,267.84Zm3.14-4.25-.21-.65a.82.82,0,0,0-1-.51l-1.53.5a.71.71,0,0,1,.28.09.94.94,0,0,1,.33.73l-.09,0c0-.59-.22-.93-1.27-.59-1.78.59-.41,1.25,0,2.49s-.33,2.59,1.44,2,.4-1.25,0-2.49a3.39,3.39,0,0,1-.15-.89Zm-1.61,2.35.11.19c.26.4.47.73.33,1.08a.69.69,0,0,1-.16.22l1.52-.5a.84.84,0,0,0,.55-1l-.21-.65Zm1.64-2.27-2.17.71a3,3,0,0,0,.47,1.48l2.17-.71Z",
                                                      "data-name":
                                                        "b30bbf42-e8c3-4e24-9894-3ef4de48d74b",
                                                      fill:
                                                        "url(#ac1eb1db-a026-46b8-8ec2-eedc30bcba56)",
                                                      "fill-opacity": "0.5"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "a733c3f1-3b03-4940-a5c9-7a57b40cd1cb",
                                                      d:
                                                        "M165.54,263.37a.12.12,0,0,1-.07.14.11.11,0,0,1-.14-.08s0,0,0,0a.12.12,0,0,1,.08-.09A.11.11,0,0,1,165.54,263.37Z",
                                                      "data-name":
                                                        "f6ca271f-becd-43b7-8514-6a673d850ee6",
                                                      fill: "#414042"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "f2f22004-925b-4100-8077-71cd272e64f9",
                                                    "data-name":
                                                      "ae9d31e9-22b9-4c6b-9faa-9c329adce037"
                                                  }
                                                },
                                                [
                                                  _c("polygon", {
                                                    attrs: {
                                                      id:
                                                        "ea75c069-7a24-4bdc-9d47-df8d5d431c98",
                                                      "data-name":
                                                        "ede5a742-9e3e-459d-9758-40d0d4d7d3f0",
                                                      fill: "#f26522",
                                                      points:
                                                        "202.5 265.55 205.36 264.61 207.04 269.8 204.18 270.74 202.5 265.55"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "a743a822-cfbd-4428-9e32-e49a7309ed7a",
                                                      d:
                                                        "M203.52,268.08a3.46,3.46,0,0,1,.41-3,3.42,3.42,0,0,0-4.41,2.06,3.47,3.47,0,0,0,2,4.45,3.41,3.41,0,0,0,4-1.33A3.44,3.44,0,0,1,203.52,268.08Z",
                                                      "data-name":
                                                        "e32aa67e-cf47-4211-8c2f-3f8cb36db807",
                                                      fill: "#e52423"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "be9fb110-0270-4064-ae90-46d960567159",
                                                      d:
                                                        "M210.41,268.08l0-.11h0v0l-.1,0v0h0l0,.1Zm.2-.07,0-.13h0v.1l-.07-.08,0,0,0,.13h0l0-.1.06.07h0v-.09l0,.1Z",
                                                      "data-name":
                                                        "a3bfaec2-074c-49e2-ba1a-a1801d9c2972",
                                                      fill: "#f99f1c"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "a4d4545d-dc51-459d-9329-0a40f01fa408",
                                                      d:
                                                        "M210.06,265.93a3.48,3.48,0,0,1-2.21,4.38,3.44,3.44,0,0,1-2.24,0,3.5,3.5,0,0,0-.94-4.81,3.45,3.45,0,0,0-.74-.38,3.43,3.43,0,0,1,4.77-1A3.47,3.47,0,0,1,210.06,265.93Z",
                                                      "data-name":
                                                        "b6d47582-1d4e-4211-ac4a-1eea17a89ebc",
                                                      fill: "#f99f1c"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "b3cb5f48-bc66-4241-be34-663daaebd7a7",
                                                    "data-name":
                                                      "a51eb1bb-28f6-47d5-8731-be1a0b4b4c8e"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "af0bbee4-8142-4731-a770-157cf1a36da6",
                                                      d:
                                                        "M188,260.16l15.39-5.07a10.47,10.47,0,0,0-1.38-1.7,5,5,0,0,0-5.05-1.24l-7.91,2.61Z",
                                                      "data-name":
                                                        "ab89325c-3d95-4b5f-b234-253613f1c6a5",
                                                      fill:
                                                        "url(#bf0d6376-9bb3-4bf4-9569-9da34fc9c63c)"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "f21d4990-e51c-4921-8d06-f578c8215a24",
                                                      d:
                                                        "M198.11,240.17l7.07,6.6,2.22,6.87a4.83,4.83,0,0,1-3.62-.85l-.05,0-7.49-7-1.38,7.11-.58,3c-.35,1.66-1.59,2.76-3.62,3.43l-2.65.87,1.05-5.4.81-4.17h0l.19-1,1.42-7.29Z",
                                                      "data-name":
                                                        "af523ff0-8073-4614-a796-17492b6a543f",
                                                      fill:
                                                        "url(#f24abdd8-7e6e-4ee2-873f-0a00f0f6cc10)"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "efecdd6a-8a07-480a-9d84-525519df4a9c",
                                                      d:
                                                        "M198.1,240.17l7.08,6.61,2.22,6.86a4.87,4.87,0,0,1-3.62-.84l-.05-.05-7.49-7c-2.68-2.44-5.52.51-6.18,3.89h0l1.42-7.28Z",
                                                      "data-name":
                                                        "ad271562-437c-4dd1-8a2d-2d55419fbe55",
                                                      fill:
                                                        "url(#fb07e921-d3b5-4bf4-a879-41f06a5c7bd1)"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "a78afaf0-b51d-4433-b45b-867c60bdf921",
                                                    "data-name":
                                                      "e69a3d04-1494-496b-9959-fe37bd632452"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "g",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "f95e457a-fc24-4dce-a649-624c88d8b5be",
                                                        "data-name":
                                                          "a5875fb6-5a24-4b62-813a-1340cc3cc59f"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "b295bbf7-9365-4a90-86c9-c0c24779f935",
                                                          d:
                                                            "M176,255.46l2.09-.69a1,1,0,0,0-.19-.23.69.69,0,0,0-.68-.17l-1.08.36Z",
                                                          "data-name":
                                                            "bcef0181-0c7b-49e7-92eb-c9740ffc8a13",
                                                          fill:
                                                            "url(#b006f3f2-cf73-4a77-9c4d-8b64cff284c7)"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "b38a38a5-006e-439e-98fa-56c2cc65fc2b",
                                                          d:
                                                            "M176.26,254h0l0,.13h0l-.11.57-.14.73.36-.11a.68.68,0,0,0,.49-.47l.08-.41.19-1,1,.95a.72.72,0,0,0,.67.09l.36-.12-2.52-2.35Z",
                                                          "data-name":
                                                            "acc82ba8-cc8a-4ca3-850b-aa78b2564d7f",
                                                          fill:
                                                            "url(#b58f51ca-3728-4f51-a31d-ef6fee9682a0)"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          id:
                                                            "ecea910e-c58c-4e43-93cf-caf45724995a",
                                                          d:
                                                            "M176.26,254c.09-.46.47-.87.84-.53l1,.95a.73.73,0,0,0,.67.09l.36-.12-2.51-2.35Z",
                                                          "data-name":
                                                            "b5a7abce-9fa4-492d-a200-09ec1936c5a5",
                                                          fill:
                                                            "url(#e84e8c37-3714-4e10-909e-0e61014d2f50)"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("polygon", {
                                                    attrs: {
                                                      id:
                                                        "beef07d9-c15d-4862-a2a3-c03405a89142",
                                                      "data-name":
                                                        "b0f74388-d854-425b-9f73-54ed5ad64d4c",
                                                      fill: "#fff",
                                                      points:
                                                        "171.79 255.54 171.5 256.17 171.73 256.91 171.19 257.09 170.26 254.19 170.8 254.01 171.28 255.49 172.21 253.55 172.81 253.35 172.03 255.04 173.8 256.21 173.18 256.42 171.79 255.54"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "f2d76e83-ffae-466e-9a5e-531543efb16a",
                                                      d:
                                                        "M163,257.34a1.55,1.55,0,0,0-.73-.35,1.76,1.76,0,0,0-.85.07h0a1.76,1.76,0,0,0-.72.45,1.49,1.49,0,0,0-.38.71,1.63,1.63,0,0,0,.49,1.53,1.49,1.49,0,0,0,.71.35,1.74,1.74,0,0,0,.85-.07h0a1.73,1.73,0,0,0,.73-.45,1.44,1.44,0,0,0,.37-.71,1.63,1.63,0,0,0-.49-1.53Zm-.05,1.44a1,1,0,0,1-.25.47,1.12,1.12,0,0,1-.47.3h0a1.06,1.06,0,0,1-.56,0,.92.92,0,0,1-.47-.24,1.18,1.18,0,0,1-.34-1.05,1,1,0,0,1,.24-.48,1.12,1.12,0,0,1,.47-.3h0a1.18,1.18,0,0,1,.56,0,1,1,0,0,1,.48.25A1.17,1.17,0,0,1,163,258.78Z",
                                                      "data-name":
                                                        "ea70296a-e29c-4316-957f-fbd057fa0c8e",
                                                      fill: "#fff"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      id:
                                                        "abc1ae6b-20aa-460d-b8f8-5dbfcabaf8f0",
                                                      d:
                                                        "M167.73,257.18a1,1,0,0,0,.34-.5,1.06,1.06,0,0,0,0-.61,1.07,1.07,0,0,0-.33-.5.89.89,0,0,0-.53-.22,1.74,1.74,0,0,0-.68.08l-1.18.39.92,2.88.53-.18L166,256.1l.62-.21a.89.89,0,0,1,.58,0,.63.63,0,0,1,.29.82l0,0a.81.81,0,0,1-.48.32l-.08,0,.14.44.22-.07.86.64.57-.18Z",
                                                      "data-name":
                                                        "f67f4c64-cadf-4f8f-ba7a-1a505f25a426",
                                                      fill: "#fff"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id:
                                                  "bde4fc26-e6b6-421d-94b8-8572879b56b4",
                                                "data-name": "pins"
                                              }
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "ae9d21f2-c2f1-4b22-84bb-26b53669ea8b",
                                                    "data-name": "pin-150"
                                                  }
                                                },
                                                [
                                                  _c("ellipse", {
                                                    attrs: {
                                                      id:
                                                        "a10fca1a-d740-418d-8641-2f0b2b259d96",
                                                      cx: "250.94",
                                                      cy: "73.34",
                                                      "data-name": "bg",
                                                      fill:
                                                        "url(#a1536304-349a-4699-a4a8-cbfdc089bd2e)",
                                                      rx: "30.19",
                                                      ry: "30.49",
                                                      stroke:
                                                        "url(#faa75c04-3476-4937-b704-e7ac0758b065)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "bfce0332-09f1-4b33-8cbb-49805192d3b8",
                                                      cx: "251.04",
                                                      cy: "73.45",
                                                      "data-name": "pulse-1",
                                                      fill: "none",
                                                      opacity: "0.5",
                                                      rx: "40.25",
                                                      ry: "40.66",
                                                      stroke:
                                                        "url(#a1fab673-ffbb-48ff-af3e-2d6285600787)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "f6168909-f1cf-4ae3-bfe0-fb7f4369c721",
                                                      cx: "251.04",
                                                      cy: "73.45",
                                                      "data-name": "pulse-2",
                                                      fill: "none",
                                                      opacity: "0.25",
                                                      rx: "50.32",
                                                      ry: "50.82",
                                                      stroke:
                                                        "url(#ed561c86-fb10-44d1-9abb-a67bfc08486e)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "e26a7e6c-35c1-4f95-b7f7-be299345b2ef",
                                                      d:
                                                        "M241.69,72.93h-7.57V72h1.67a5.29,5.29,0,0,1,5.16-4.1,5.65,5.65,0,0,1,4.14,1.87L244,70.85a4.19,4.19,0,0,0-3-1.4A3.66,3.66,0,0,0,237.5,72h4.19Zm3.41,4a5.61,5.61,0,0,1-4.15,1.9,5.29,5.29,0,0,1-5.16-4.12h-1.67v-.91h7.57v.91H237.5A3.66,3.66,0,0,0,241,77.26a4.24,4.24,0,0,0,3-1.41Zm4.56-9V78.64h-1.58V70.17l-2.27.91V69.55l3.77-1.68Zm9.27,7.29a3.56,3.56,0,0,1-3.8,3.65,4.2,4.2,0,0,1-3.83-2.38l1.3-.76a2.63,2.63,0,0,0,2.45,1.62,2.11,2.11,0,0,0,2.29-2.1,2.08,2.08,0,0,0-2.22-2.09,4.26,4.26,0,0,0-2.52,1l-1-.77.91-5.32h5.69v1.52h-4.38l-.56,2.91a3.67,3.67,0,0,1,2.2-.72A3.28,3.28,0,0,1,258.93,75.16Zm1.16-1.8c0-3,.79-5.49,3.83-5.49s3.84,2.44,3.84,5.49-.81,5.45-3.84,5.45S260.09,76.35,260.09,73.36Zm6.07,0c0-2.17-.45-4-2.24-4s-2.25,1.8-2.25,4,.47,3.93,2.25,3.93S266.16,75.5,266.16,73.36Z",
                                                      "data-name": "price"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "ed37ba25-c0fe-445b-a67b-b5fee71bc7c3",
                                                    "data-name": "pin-90"
                                                  }
                                                },
                                                [
                                                  _c("ellipse", {
                                                    attrs: {
                                                      id:
                                                        "fe52c638-ff37-4e52-b8b1-e6f048d1f216",
                                                      cx: "66.06",
                                                      cy: "145.17",
                                                      "data-name": "bg",
                                                      fill:
                                                        "url(#ea6028c8-cba8-4de6-8d75-b4fc440a46c3)",
                                                      rx: "30.19",
                                                      ry: "30.49",
                                                      stroke:
                                                        "url(#b1107e64-9965-460d-937f-9074397f82d2)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "a47bc6f4-79aa-4f9c-a3c7-4dee11f09b8e",
                                                      cx: "65.88",
                                                      cy: "144.6",
                                                      "data-name": "pulse-1",
                                                      fill: "none",
                                                      opacity: "0.5",
                                                      rx: "40.25",
                                                      ry: "40.66",
                                                      stroke:
                                                        "url(#bc5384f4-3a01-4ba7-9933-eba93d8026c2)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "bb751500-d81f-4420-9697-78b8d7ae563a",
                                                      cx: "65.88",
                                                      cy: "144.6",
                                                      "data-name": "pulse-2",
                                                      fill: "none",
                                                      opacity: "0.25",
                                                      rx: "50.32",
                                                      ry: "50.82",
                                                      stroke:
                                                        "url(#b8ad1d61-26d1-4c65-9db7-9ab0931650e3)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "e953323c-c126-43d1-bf9b-b9d584506093",
                                                      d:
                                                        "M59.32,144.13H51.75v-.91h1.67a5.29,5.29,0,0,1,5.16-4.1A5.65,5.65,0,0,1,62.72,141l-1.13,1.06a4.23,4.23,0,0,0-3-1.4,3.66,3.66,0,0,0-3.45,2.57h4.19Zm3.41,4a5.61,5.61,0,0,1-4.15,1.9,5.29,5.29,0,0,1-5.16-4.11H51.75V145h7.57v.92H55.13a3.67,3.67,0,0,0,3.45,2.58,4.24,4.24,0,0,0,3-1.41Zm8.86-3.84c0,2.65-1.11,5.76-4.37,5.76a3.31,3.31,0,0,1-3.28-2.17l1.4-.61a2,2,0,0,0,1.9,1.27c1.53,0,2.71-1.62,2.66-3.58a3,3,0,0,1-2.45,1.18,3.51,3.51,0,0,1-3.61-3.51,3.57,3.57,0,0,1,3.77-3.52C70.19,139.07,71.59,141.25,71.59,144.25Zm-1.76-1.55a2.1,2.1,0,0,0-2.14-2.1,2.06,2.06,0,0,0-2.21,2,2,2,0,0,0,2,2A2.14,2.14,0,0,0,69.83,142.7Zm3.06,1.86c0-3,.79-5.49,3.83-5.49s3.84,2.45,3.84,5.49S79.75,150,76.72,150,72.89,147.55,72.89,144.56Zm6.07,0c0-2.17-.45-4-2.24-4s-2.25,1.8-2.25,4,.47,3.94,2.25,3.94S79,146.71,79,144.56Z",
                                                      "data-name": "price"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "a07c8b98-75d3-41ee-83bb-3d65b2d985ca",
                                                    "data-name": "pin-230"
                                                  }
                                                },
                                                [
                                                  _c("ellipse", {
                                                    attrs: {
                                                      id:
                                                        "a9be7c08-93e8-4e96-9fab-9d16426da081",
                                                      cx: "140.29",
                                                      cy: "273.07",
                                                      "data-name": "bg",
                                                      fill:
                                                        "url(#f77690e5-74b2-484a-b3f1-fd0b3dc63173)",
                                                      rx: "30.19",
                                                      ry: "30.49",
                                                      stroke:
                                                        "url(#a08b30f9-909e-49dc-bef1-95d6d07d7cdf)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "bfdfa707-22f5-4201-86b5-651d78a816fa",
                                                      cx: "140.35",
                                                      cy: "272.68",
                                                      "data-name": "pulse-1",
                                                      fill: "none",
                                                      opacity: "0.5",
                                                      rx: "40.25",
                                                      ry: "40.66",
                                                      stroke:
                                                        "url(#a100c7cb-2670-4d71-a661-5d65e7145eda)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "e5c25b45-9237-4c95-b228-39cba456ac0f",
                                                      cx: "140.35",
                                                      cy: "272.68",
                                                      "data-name": "pulse-2",
                                                      fill: "none",
                                                      opacity: "0.25",
                                                      rx: "50.32",
                                                      ry: "50.82",
                                                      stroke:
                                                        "url(#e1219542-7397-4c44-9871-4b4ca756b7c8)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "a8975557-7c63-4236-94af-477f052c2758",
                                                      d:
                                                        "M130,272.67h-7.57v-.91h1.68a5.26,5.26,0,0,1,5.15-4.1,5.6,5.6,0,0,1,4.14,1.87l-1.13,1.06a4.19,4.19,0,0,0-3-1.4,3.65,3.65,0,0,0-3.45,2.57H130Zm3.42,3.95a5.66,5.66,0,0,1-4.16,1.91,5.28,5.28,0,0,1-5.15-4.12h-1.68v-.91H130v.91h-4.19A3.68,3.68,0,0,0,129.3,277a4.25,4.25,0,0,0,3-1.42Zm7.8.23v1.53h-6.75v-.75l4-4.85a4,4,0,0,0,1-2,1.61,1.61,0,0,0-1.78-1.64,1.75,1.75,0,0,0-1.9,1.6l-1.42-.3a3.12,3.12,0,0,1,3.33-2.81,3.07,3.07,0,0,1,3.35,3.15,4.61,4.61,0,0,1-1.21,2.75l-2.77,3.34Zm7.93-1.58c0,2-1.52,3.26-3.69,3.26a3.73,3.73,0,0,1-3.43-2.17l1.25-.76a2.48,2.48,0,0,0,2.11,1.43c1.26,0,2.16-.7,2.16-1.74a1.94,1.94,0,0,0-2.14-1.91h-1.08v-1.31h.92a1.59,1.59,0,0,0,1.8-1.57,1.4,1.4,0,0,0-1.58-1.38,2.32,2.32,0,0,0-1.83,1l-1-.93a3.51,3.51,0,0,1,2.94-1.54,2.82,2.82,0,0,1,3.1,2.86,2.38,2.38,0,0,1-1.34,2.2A2.68,2.68,0,0,1,149.19,275.27Zm1.25-2.18c0-3,.79-5.48,3.83-5.48s3.84,2.44,3.84,5.48-.81,5.45-3.84,5.45S150.44,276.08,150.44,273.09Zm6.07,0c0-2.16-.45-4-2.24-4s-2.25,1.81-2.25,4,.46,3.94,2.25,3.94S156.51,275.24,156.51,273.09Z",
                                                      "data-name": "price"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    id:
                                                      "b5d79658-492b-48b7-b2a7-f854b584b62b",
                                                    "data-name": "pin-point"
                                                  }
                                                },
                                                [
                                                  _c("ellipse", {
                                                    attrs: {
                                                      id:
                                                        "f8b9c51d-c08d-4b6a-b539-dd1544d6f99b",
                                                      cx: "280.83",
                                                      cy: "293.62",
                                                      "data-name": "pulse-1",
                                                      fill: "none",
                                                      rx: "9.66",
                                                      ry: "9.76",
                                                      stroke:
                                                        "url(#ab3168a4-7b0f-4966-88f8-ee228a8166d8)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                      "stroke-width": "0.8"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    attrs: {
                                                      id:
                                                        "af59beb8-74b3-4a3d-b95a-8b074b79edea",
                                                      cx: "280.83",
                                                      cy: "293.62",
                                                      "data-name": "bg",
                                                      fill:
                                                        "url(#a7f8c06f-b184-4ad5-9b40-784e2bb4dd82)",
                                                      rx: "4.83",
                                                      ry: "4.88"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "b763727f-4918-4a99-aa01-1ad03e20a4a1",
                                                      cx: "280.83",
                                                      cy: "293.62",
                                                      "data-name": "pulse-2",
                                                      fill: "none",
                                                      opacity: "0.25",
                                                      rx: "17.71",
                                                      ry: "17.89",
                                                      stroke:
                                                        "url(#b3069ab3-8534-4e49-9f80-f588ad6e076b)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                      "stroke-width": "0.8"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ellipse", {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      id:
                                                        "a03cdafe-f805-4a42-a702-f8bb2c75d0a9",
                                                      cx: "280.83",
                                                      cy: "293.62",
                                                      "data-name": "pulse-3",
                                                      fill: "none",
                                                      opacity: "0.1",
                                                      rx: "25.76",
                                                      ry: "26.02",
                                                      stroke:
                                                        "url(#b3b016e8-dbf2-4a99-9ab2-3e35566d11a0)",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                      "stroke-width": "0.8"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-image", {
                                    attrs: {
                                      "aspect-ratio": 1,
                                      tiny: {
                                        default: require("@/images/gold/carousel/globe.png"),
                                        retina: require("@/images/gold/carousel/globe@2.png")
                                      },
                                      alt: "todo fill alt"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "carousel__right" }, [
                    _c(
                      "div",
                      { staticClass: "carousel__item" },
                      [
                        _vm._l(1, function(i) {
                          return [
                            _c(
                              "div",
                              {
                                ref: "content",
                                refInFor: true,
                                staticClass: "carousel__content"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "carousel__content-inner" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        ref: "contentTrigger",
                                        refInFor: true,
                                        staticClass:
                                          "carousel__headline-wrapper"
                                      },
                                      [
                                        _c("v-typo", {
                                          staticClass: "carousel__headline",
                                          attrs: { variant: "h2" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "cards.gold.carousel.live.headline"
                                              )
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-typo", {
                                      staticClass: "carousel__paragraph",
                                      attrs: { variant: "body-paragraph" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "cards.gold.carousel.live.paragraph"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "carousel__content-image"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            "aspect-ratio": 1,
                                            tiny: {
                                              default: require("@/images/gold/carousel/live/live.png"),
                                              retina: require("@/images/gold/carousel/live/live@2.png")
                                            },
                                            alt: "todo fill alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                ref: "content",
                                refInFor: true,
                                staticClass: "carousel__content"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "carousel__content-inner" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        ref: "contentTrigger",
                                        refInFor: true,
                                        staticClass:
                                          "carousel__headline-wrapper"
                                      },
                                      [
                                        _c("v-typo", {
                                          staticClass: "carousel__headline",
                                          attrs: { variant: "h2" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "cards.gold.carousel.travel.headline"
                                              )
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-typo", {
                                      staticClass: "carousel__paragraph",
                                      attrs: { variant: "body-paragraph" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "cards.gold.carousel.travel.paragraph"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "carousel__content-image"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            "aspect-ratio": 1,
                                            tiny: {
                                              default: require("@/images/gold/carousel/live/live.png"),
                                              retina: require("@/images/gold/carousel/live/live@2.png")
                                            },
                                            alt: "todo fill alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                ref: "content",
                                refInFor: true,
                                staticClass: "carousel__content"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "carousel__content-inner" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        ref: "contentTrigger",
                                        refInFor: true,
                                        staticClass:
                                          "carousel__headline-wrapper"
                                      },
                                      [
                                        _c("v-typo", {
                                          staticClass: "carousel__headline",
                                          attrs: { variant: "h2" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t(
                                                "cards.gold.carousel.payments.headline"
                                              )
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-typo", {
                                      staticClass: "carousel__paragraph",
                                      attrs: { variant: "body-paragraph" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "cards.gold.carousel.payments.paragraph"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "carousel__content-image"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            "aspect-ratio": 1,
                                            tiny: {
                                              default: require("@/images/gold/carousel/live/live.png"),
                                              retina: require("@/images/gold/carousel/live/live@2.png")
                                            },
                                            alt: "todo fill alt"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ])
                ]
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { ref: "carouselBG", staticClass: "carousel__sticky-bg" },
          [
            _c("v-image", {
              attrs: {
                "aspect-ratio": false,
                tiny: {
                  default: require("@/images/gold/ultimate/bg.jpg"),
                  retina: require("@/images/gold/ultimate/bg@2.jpg")
                },
                alt: "Background"
              }
            }),
            _vm._v(" "),
            _c("v-icon", {
              staticClass: "carousel__sticky-item",
              attrs: { name: "symbols/cards/gold" }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "see-world" },
      [
        _c(
          "div",
          { staticClass: "see-world__background" },
          [
            _c("v-image", {
              attrs: {
                "aspect-ratio": false,
                tiny: {
                  default: require("@/images/gold/ultimate/bg.jpg"),
                  retina: require("@/images/gold/ultimate/bg@2.jpg")
                },
                alt: "Background"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "see-world__bg" },
          [
            _c("v-image", {
              staticClass: "see-world__image",
              attrs: {
                alt: "TODO Fill Alt",
                "aspect-ratio": 1,
                tiny: {
                  default: require("@/images/gold/seeWorld.png"),
                  retina: require("@/images/gold/seeWorld@2.png")
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "v-row",
          {
            staticClass: "see-world__row",
            attrs: { horizonta: "center", variant: "flex", vertical: "center" }
          },
          [
            _c("v-column", { attrs: { large: 12 } }, [
              _c("div", { staticClass: "see-world__wrapper" }, [
                _c(
                  "div",
                  { staticClass: "see-world__content" },
                  [
                    _c("v-typo", {
                      attrs: { variant: "h1" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("cards.gold.seeWorld.headline")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("v-typo", {
                      staticClass: "see-world__paragraph",
                      attrs: { variant: "body-paragraph" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("cards.gold.seeWorld.paragraph")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "v-button",
                      {
                        staticClass: "see-world__button",
                        attrs: {
                          to: {
                            query: {
                              modal: _vm.appModalName,
                              params: {
                                card: "gold"
                              }
                            }
                          },
                          variant: "gold"
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("button.getItNow")) +
                            "\n\t\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }